import { faCircleCheck, faCircleXmark, faEye } from '@fortawesome/free-regular-svg-icons';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import $ from "jquery";
import React, { useEffect, useRef, useState } from 'react';
import { Badge, Button, Col, Container, Form, Modal, Row, Tab, Table, Tabs } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { useNavigate } from 'react-router-dom';
import Select from "react-select";
import AsyncSelect from 'react-select/async';
import "../../mcss/main.css";
import ActivityLog from '../ActivityLog';
import CancelDialog from '../CancelDialog';
import * as Common from "../Common";
import Dialog from '../Dialog';
import Dialog_IRN from '../Dialog_IRN';
import DialogYesNo from '../Dialog_Yes_No';
import FaView from '../FaView';
import LoginHeader from '../Login_header';
import Master_individual_profile from '../master/Master_individual_profile';
import Menu from '../Menu';
import * as Picklist from "../Picklist";
import Tran_data_unlock_request from '../Tran_data_unlock_request';
import Tran_date_change_modal from './Tran_date_change_modal';
import Tran_passport_form from './Tran_passport_form';

function Tran_pp() {
    const productRef = useRef();
    const finStartDate = sessionStorage.getItem("startDate");
    const finEndDate = sessionStorage.getItem("endDate");
    const branchDisable = sessionStorage.getItem('branchDisable');

    const [isMsgBoxYN, setMsgBoxYN] = useState(false);
    const [msgTextYN, setMsgTextYN] = useState("");

    const sid = sessionStorage.getItem("sessionId");
    const navigate = useNavigate();
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");
    const [radioType, setRadioType] = useState("N");

    const [ppNewDate, setPPNewDate] = useState(new Date());
    const [ppSrnoFrom, setPPSrnoFrom] = useState("");
    const [ppSrnoTo, setPPSrnoTo] = useState("");
    const [ppFromDate, setPPFromDate] = useState(new Date());
    const [ppToDate, setPPToDate] = useState(new Date());

    const [ppList, setPPList] = useState([]);

    const [ppLocation, setPPLocation] = useState(null);
    const [ppLocationValue, setPPLocationValue] = useState(0);
    const [ppCorporate, setPPCorporate] = useState(null);
    const [ppIndividual, setPPIndividual] = useState(null);
    const [ppStateType, setPPStateType] = useState(0);
    const [ppStateValue, setPPStateValue] = useState(0);
    const [ppStateName, setPPStateName] = useState("");
    const [userRight, setUserRight] = useState([]);

    const [scrMode, setScrMode] = useState("");
    const [showIndividualForm, setShowIndividualForm] = useState(false);

    const [isdOptions, setIsdOptions] = useState([]);
    const [residentOptions, setResidentOptions] = useState([]);
    const [stateOptions, setStateOptions] = useState([]);
    const [nPurpose, setNPurpose] = useState(null);
    const [hdrSrno, setHdrSrno] = useState(0);
    const [nIndividual, setNIndividual] = useState(null);
    const [nState, setNState] = useState({ value: 0, label: "Select" });
    const [nCountry, setNCountry] = useState(null);
    const [nServiceType, setNServiceType] = useState("");
    const [nEmployeeCode, setNEmployeeCode] = useState("");
    const [nResident, setNResident] = useState("1");
    const [nCorporate, setNCorporate] = useState(null);
    const [nDocument, setNDocument] = useState("P");
    const [nDealer, setNDealer] = useState(null);
    const [nManualNo, setNManualno] = useState(null);
    const [nExecutive, setNExecutive] = useState(null);
    const [nSubExecutive, setNSubExecutive] = useState(null);
    const [nRemark1, setNRemark1] = useState("");
    const [nRemark2, setNRemark2] = useState("");
    const [nArrivalDate, setNArrivalDate] = useState(null);
    const [nCDFNum, setNCDFNum] = useState("");
    const [nLrsReverse, setNLrsReverse] = useState(1);
    const [nMode, setNMode] = useState("B");

    const [pIssuer, setPIssuer] = useState(null);
    const [pIsd, setPIsd] = useState(null);
    const [pDenomination, setPDenomination] = useState("");
    const [pQuantity, setPQuantity] = useState("");
    const [pRate, setPRate] = useState("");
    const [pProduct, setPProduct] = useState("CN");
    const [randomString, setRandomString] = useState("");
    const [pProductList, setPProductList] = useState([]);

    const [pVtm, setPVtm] = useState(null);
    const [pTotalAmount, setPTotalAmount] = useState(0);
    const [pOtherCharges, setPOtherCharges] = useState(0);
    const [pCgst, setPCgst] = useState(0);
    const [pSgst, setPSgst] = useState(0);
    const [pIgst, setPIgst] = useState(0);
    const [pUgst, setPUgst] = useState(0);
    const [pForexTotal, setPForexTotal] = useState(0);
    const [pRoundOff, setPRoundOff] = useState(0);
    const [pTaxableVal, setPTaxableVal] = useState(0);
    const [disableOtherCharge, setDisableOtherCharge] = useState(true);

    const [prPrefix, setPrPrefix] = useState("");
    const [prFrom, setPrFrom] = useState("");
    const [prTo, setPrTo] = useState("");
    const [pVtmCardNo, setPVtmCardNo] = useState("");
    const [pAgent, setPAgent] = useState(null);
    const [isCommission, setIsCommission] = useState("0");
    const [commType, setCommType] = useState("F");
    const [commValue, setCommValue] = useState("");

    const [pdAccount, setPdAccount] = useState(null);
    const [pdPaymentType, setPdPaymentType] = useState("");
    const [pdAmount, setPdAmount] = useState("");
    const [key, setKey] = useState("INFO");
    const [pdAccountOptions, setPdAccountOptions] = useState([]);
    const [pdAccountValue, setPdAccountValue] = useState("");
    const [pdGroupValue, setPdGroupValue] = useState(0);
    const [pdChequeNum, setPdChequeNum] = useState("");
    const [paymentData, setPaymentData] = useState([]);
    const [ldgSrchType, setLdgSrchType] = useState("");
    const [commission, setCommission] = useState("");
    const [pIsdId, setPIsdId] = useState("");
    const [maxPRate, setMaxPRate] = useState(0);
    const [minPRate, setMinPRate] = useState(0);

    const [counter, setCounter] = useState(0);
    const [productLineNo, setProductLineNo] = useState(0);
    const [paymentLineNo, setPaymentLineNo] = useState(0);

    const [printFlag, setPrintFlag] = useState('');
    const [chequeValue, setChequeValue] = useState(null);
    const [chequeNum, setChequeNum] = useState(0);
    const [chequeLocation, setChequeLocation] = useState(0);
    const [chequeLineNo, setChequeLineNo] = useState(0);
    const [chequeSrno, setChequeSrno] = useState(0);

    const [nIndivualSrno, setNIndivualSrno] = useState("");
    const [scrIndividual, setScrIndividual] = useState("");

    const [hdrDate, setHdrDate] = useState(null);
    const [hdrLocation, setHdrLocation] = useState("");

    const [faViewObject, setFaViewObject] = useState({ location: "", trannumber: "", type: "" });
    const [showFaView, setShowFaView] = useState(false);

    const [viewDate, setViewDate] = useState('');
    const currentDate = new Date();
    const [showEditRequest, setShowEditRequest] = useState(false);
    const [editLogObject, setEditLogObject] = useState({ trantype: "", trannumber: "", trancategory: "", tranDate: "" });

    const [usdRate, setUSDRate] = useState('');

    const [ppManualNo, setPPManualNo] = useState('');
    const [arrivalSelected, setArrivalSelected] = useState(0);
    const [individualSelected, setIndividualSelected] = useState(0);
    const [showPreviousTransactionModal, setShowPreviousTransactionModal] = useState(false);
    const [showMinMaxRateModal, setShowMinMaxRateModal] = useState(false);

    const [preTransaction, setPreTransaction] = useState([]);

    const [tranAuditTrail, setTranAuditTrail] = useState([]);
    const [minMaxRate, setMinMaxRate] = useState([]);
    const [showActivityLog, setShowActivityLog] = useState(false);
    const [logObject, setLogObject] = useState({ trantype: "", trannumber: "", trancategory: "" });

    const [disablePaymentAccount, setDisablePaymentAccount] = useState(true);
    const [filterProduct, setFilterProduct] = useState("C");
    const [showCommissionDetail, setShowCommissionDetail] = useState(false);

    const [isMsgBoxCancelBill, setMsgBoxCancelBill] = useState(false);
    const [msgTextCancelBill, setMsgTextCancelBill] = useState("");
    const [irnCancelReason, setIrnCancelReason] = useState("");
    const [irnCancelLabel, setIrnCancelLabel] = useState("");
    const [irnCancelDeclaration, setIrnCancelDeclaration] = useState(false);

    const [isIrnGenerated, setIsIrnGenerated] = useState("0");
    const [irnObj, setIrnObj] = useState({ irn: "", ackdate: "", acknum: "", signedqr: "" });
    const [isIrnCancelled, setIsIrnCancelled] = useState("0");
    const [irnCancelDate, setIrnCancelDate] = useState("");
    const [isIrnApplicable, setIsIrnApplicable] = useState("N");
    const [irnCancelReasonHdr, setIrnCancelReasonHdr] = useState("");
    const [irnCancelReasonSelect, setIrnCancelReasonSelect] = useState("");

    const [hdrDateYmd, setHdrDateYmd] = useState("");
    const [corpServiceCharge, setCorpServiceCharge] = useState(0);
    const [irnCancelRemarkHdr, setIrnCancelRemarkHdr] = useState("");
    const [unlockRequestType, setUnlockRequestType] = useState("");
    const [evtmNum, setEvtmNum] = useState("");
    const [pTravellerName, setPTravellerName] = useState("");
    const [pIdType, setPIdType] = useState("0");
    const [pIdNumber, setPIdNumber] = useState("");
    const [pIdExpiryDate, setPidExpiryDate] = useState(new Date());
    const [pIdIssueDate, setPidIssueDate] = useState(new Date());

    const [idTypeList, setIdTypeList] = useState([]);
    const [evtmIndividualSrno, setEvtmIndividualSrno] = useState("");
    const [isIDIssueDate, setIsIDIssueDate] = useState(0);
    const [isIDExpiryDate, setIsIDExpiryDate] = useState(0);

    const [deletedVtmSrno, setDeletedVtmSrno] = useState("");
    const [compareData, setCompareData] = useState([]);

    const [dsrRate, setDsrRate] = useState("");
    const [openDateChangeModal, setOpenDateChangeModal] = useState(false);
    const [changeDateObj, setChangeDateObj] = useState({});
    const [dateChangeRight, setDateChangeRight] = useState();


    const [userCancelBillRight, setUserCancelBillRight] = useState([]);
    const [msgBoxYNBillDelete, setMsgBoxYNBillDelete] = useState(false);
    const [msgTextYNBillDelete, setMsgTextYNBillDelete] = useState("");

    const [isMsgBoxYNevtm, setMsgBoxYNevtm] = useState(false);
    const [msgTextYNevtm, setMsgTextYNevtm] = useState("");

    const [acRemark, setAcRemark] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [riskValue, setRiskValue] = useState("0");
    const [riskModalBoxText, setRiskModalBoxText] = useState("");
    const [cancelButtonView, setCancelButtonView] = useState(true);
    const [profileCnt, setProfileCnt] = useState(0);
    const [cntIssue, setCntIssue] = useState(0);
    const [createIndivisualByPassport, setCreateIndivisualByPassport] = useState(null);
    const [showPassForm, setShowPassForm] = useState(false);


    const [isBranchDisableForAddNew, setIsBranchDisableForAddNew] = useState("");
    const [isAirport, setIsAirport] = useState("0");
    const [otherChargesInputVisibility, setOtherChargesInputVisibility] = useState(false)
    const [pExclusiveGst, setPExclusiveGst] = useState(0);


    const [individualName, setIndividualName] = useState("");
    const [individualPan, setIndividualPan] = useState("");
    const [individualAddress, setIndividualAddress] = useState("");

    const [corporateName, setCorporateName] = useState("");
    const [corporatePan, setCorporatePan] = useState("");
    const [corporateAddress, setCorporateAddress] = useState("");
    const [corporateGstin, setCorporateGstin] = useState("");

    const [dealerName, setDealerName] = useState("");
    const [dealerPan, setDealerPan] = useState("");
    const [dealerAddress, setDealerAddress] = useState("");
    const [dealerGsitn, setDealerGstin] = useState("");

    const [agentName, setAgentName] = useState("");
    const [agentAddress, setAgentAddress] = useState("");
    const [agentPan, setAgentPan] = useState("");
    const [corpName, setCorpName] = useState('');
    const [trandate, setTrandate] = useState(null);

    const [individualId, setIndividualId] = useState("");
    const [individualNumber, setIndividualNumber] = useState("");
    const [ldgAllBank, setLdgAllBank] = useState(null);
    const [ldgAllBankCode, setLdgAllBankCode] = useState("");
    const [nAccountNo, setNAccountNo] = useState("");
    const [nIfscCode, setNIfscCode] = useState("");
    const [spLocationValue, setSPLocationValue] = useState("");

    // state added for IRN pause functionality
    const [confirmResolve, setConfirmResolve] = useState(null);
    const [irnPauseRight, setIRNPauseRight] = useState(null);
    const [checkIsirn, setIsirn] = useState(null);
    const [cardNoDoesNotWithIndi, setCardNoDoesNotWithIndi] = useState("");



    useEffect(() => {
        if (sessionStorage.getItem("activeBranch") == Common.HoCode) {
            sessionStorage.activeBranch = sessionStorage.getItem('activeBranchWithoutHo');
        }
        Common.getActiveBranch().then(response => {
            setPPLocation(response);
            response != null && handleLocationChange(response);
        });

        Common.callApi(Common.apiRight, [sid, 'all', 'TRAN_PP'], function (result) {
            let resp = JSON.parse(result);
            if (+resp.query === 1) {
                setUserRight(resp);
            } else {
                navigate('/'); // no query right
            }
        });
        Common.callApi(Common.apiRight, [sid, 'all', 'TRAN_DELETE_BILL'], function (result) {
            let resp = JSON.parse(result);
            if (+resp.query === 1) {
                setUserCancelBillRight(resp);
            }
        });

        Common.callApi(Common.apiIsd, [sid, "ddlistjsonselect", pProduct], result => {
            setIsdOptions(JSON.parse(result));
        });
        Common.callApi(Common.apiResidentialStatus, [sid, "listResidential"], result => {
            setResidentOptions(JSON.parse(result));
        });
        Common.callApi(Common.apiState, [sid, "getState", 1], result => {
            setStateOptions(JSON.parse(result));
        });
        //get CREATE_INDIVIDUAL_BY_PASPPORT ===========================
        Common.callApi(Common.apiRight, [sid, 'all', 'CREATE_INDIVIDUAL_BY_PASPPORT'], function (result) {
            let resp = JSON.parse(result);
            if (+resp.query === 1) {
                setCreateIndivisualByPassport(resp);
            }
        });

        Common.callApi(Common.apiRight, [sid, 'all', 'IRN_PAUSE'], function (result) {
            let resp = JSON.parse(result);
            if (+resp.query === 1) {
                setIRNPauseRight(resp);
            }
        });


        const sessionValues = sessionStorage.getItem('values');
        if (sessionValues) {
            const sessionData = JSON.parse(sessionValues);
            if (sessionData.md_type == "PURCHASE") {
                setScrMode('A');
                setNServiceType('R');
                Common.callApi(Common.apiIndividualProfile, [sid, 'getIndividualData', sessionData.code], (result) => {
                    let resp = JSON.parse(result);
                    console.log("RESPONSE IS  ", resp);
                    // const desc = resp.desc.split("^");
                    handleNewIndiviualChange({ ...resp, desc: `${resp.desc.replaceAll('^', '  ^  ')}` })
                    // setNIndividual(resp);
                });
                sessionStorage.removeItem('values');
            } else {
                setScrMode('');
            }
        }
        Common.getDateChangeRight(sid, setDateChangeRight);//get right to change date
    }, []);

    const showPassportForm = () => {
        setShowPassForm(true);
    }

    const listPPdata = () => {
        var msg = [], i = 0;
        $(".loader").show();

        if (ppLocation === null || (radioType === 'S' && !ppSrnoFrom) || (radioType === 'S' && !ppSrnoTo) || (radioType === 'D' && !ppFromDate)
            || (radioType === 'D' && !ppToDate) || (radioType === 'I' && ppIndividual === null) || (radioType === 'I' && !ppFromDate)
            || (radioType === 'I' && !ppToDate) || (radioType === 'C' && ppCorporate === null) || (radioType === 'C' && !ppFromDate)
            || (radioType === 'C' && !ppToDate) || (radioType === 'M' && !ppManualNo)
            || (radioType === 'I' && (new Date(Common.dateYMD(ppFromDate)) < new Date(finStartDate)))
            || (radioType === 'I' && (new Date(Common.dateYMD(ppToDate)) > new Date(finEndDate)))
            || (radioType === 'D' && (new Date(Common.dateYMD(ppFromDate)) < new Date(finStartDate)))
            || (radioType === 'D' && (new Date(Common.dateYMD(ppToDate)) > new Date(finEndDate)))
            || (radioType === 'C' && (new Date(Common.dateYMD(ppFromDate)) < new Date(finStartDate)))
            || (radioType === 'C' && (new Date(Common.dateYMD(ppToDate)) > new Date(finEndDate)))) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (ppLocation === null ? " Location." : '');
            msg[i++] = (radioType === 'S' && !ppSrnoFrom ? " From Srno." : '');
            msg[i++] = (radioType === 'S' && !ppSrnoTo ? " To Srno." : '');
            msg[i++] = (radioType === 'D' && !ppFromDate ? " From Date." : '');
            msg[i++] = (radioType === 'D' && !ppToDate ? " To Date." : '');
            msg[i++] = (radioType === 'I' && ppIndividual === null ? " Individual." : '');
            msg[i++] = (radioType === 'I' && !ppFromDate ? " From Date." : '');
            msg[i++] = (radioType === 'I' && (new Date(Common.dateYMD(ppFromDate)) < new Date(finStartDate)) ? `From Date Should be Greater Then  ${finStartDate.split('-').reverse().join('/')} .` : '');
            msg[i++] = (radioType === 'D' && (new Date(Common.dateYMD(ppFromDate)) < new Date(finStartDate)) ? `From Date Should be Greater Then ${finStartDate.split('-').reverse().join('/')}  .` : '');
            msg[i++] = (radioType === 'C' && (new Date(Common.dateYMD(ppFromDate)) < new Date(finStartDate)) ? `From Date Should be Greater Then ${finStartDate.split('-').reverse().join('/')}  .` : '');
            msg[i++] = (radioType === 'I' && !ppToDate ? " To Date." : '');
            msg[i++] = (radioType === 'I' && (new Date(Common.dateYMD(ppToDate)) > new Date(finEndDate)) ? ` To Date Should be Less Then ${finEndDate.split('-').reverse().join('/')} ` : '');
            msg[i++] = (radioType === 'D' && (new Date(Common.dateYMD(ppToDate)) > new Date(finEndDate)) ? ` To Date Should be Less Then ${finEndDate.split('-').reverse().join('/')} ` : '');
            msg[i++] = (radioType === 'C' && (new Date(Common.dateYMD(ppToDate)) > new Date(finEndDate)) ? ` To Date Should be Less Then ${finEndDate.split('-').reverse().join('/')} ` : '');
            msg[i++] = (radioType === 'C' && ppCorporate === null ? " Corporate." : '');
            msg[i++] = (radioType === 'C' && !ppFromDate ? " From Date." : '');
            msg[i++] = (radioType === 'C' && !ppToDate ? " To Date." : '');
            msg[i++] = (radioType === 'M' && !ppManualNo ? " Manual No." : '');

            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            const obj = {
                radioType: radioType,
                ppLocation: ppLocationValue,
                ppCorporate: ppCorporate,
                ppIndividual: ppIndividual,
                ppNewDate: Common.dateYMD(ppNewDate),
                ppSrnoTo: ppSrnoTo,
                ppSrnoFrom: ppSrnoFrom,
                ppFromDate: Common.dateYMD(ppFromDate),
                ppToDate: Common.dateYMD(ppToDate),
                ppManualNo: ppManualNo
            }
            Common.callApi(Common.apiTranPP, [sid, "pplist", JSON.stringify(obj)], result => {
                $(".loader").hide();
                setPPList(JSON.parse(result));
            });
        }
    }

    const handleTabChange = (k) => {
        setKey(k);
        if (k === "PAYMENT") {
            var amt = 0;
            for (var i = 0; i < paymentData.length; i++) {
                amt += paymentData[i].tp_amount * 1;
            }
            setPdAmount(1 * pTotalAmount - amt);
            const obj = {
                nCorporate: nCorporate
            }
            Common.callApi(Common.apiTranPP, [sid, "getcorporate", JSON.stringify(obj)], result => {
                setPdAccountOptions(JSON.parse(result));
            });
        }
    }

    const addNewForm = () => {
        var d = Common.dateYMD(ppNewDate);
        var ddmy = Common.dateDMY(ppNewDate);
        var ymd = Common.dateYMD(ppNewDate);
        var today = Common.dateYMD(new Date());

        if (ppLocation == null) {
            setMsgBox(true);
            setMsgText("Please select location");
        } else if (d > finEndDate || d < finStartDate) {
            setMsgBox(true);
            setMsgText(Common.getMessage("MSG0010"));
        } else if (d > today) {
            setMsgBox(true);
            setMsgText(Common.getMessage("MSG0011"));
        } else if (+isBranchDisableForAddNew === 1) {
            setMsgBox(true);
            setMsgText("Branch Disable .New Entry not Allowed.");
        } else {
            if (d == today) {
                addNewFormResetFields(ddmy, ymd);
            } else {
                const obj = {
                    billdate: d,
                    location: ppLocationValue,
                    type: 'PP'
                }
                Common.callApi(Common.apiDataUnlock, [sid, 'addnewunlock', JSON.stringify(obj)], result => {
                    let resp = JSON.parse(result);
                    if (+resp.msg === 1) {
                        addNewFormResetFields(ddmy, ymd);
                    } else {
                        setMsgBox(true);
                        setMsgText(Common.getMessage("MSG0012"));
                    }
                });
            }
        }
    }

    const addNewFormResetFields = (ddmy, ymd) => {
        setHdrDate(ddmy);
        setNPurpose(null);
        setScrMode('A');
        setKey('INFO');
        setProductLineNo(0);
        setPaymentLineNo(0);
        setHdrSrno(0);
        setRandomString(Common.getRandomString(20));
        setDisableOtherCharge(true);
        setNIndividual(null);
        setNIndivualSrno("");
        setIndividualSelected(0)
        setNCorporate(null);
        setNCountry(null);
        setNResident("1");
        setNEmployeeCode("");
        if (ppStateValue * 1 > 0 && ppStateValue != null) setNState({ value: ppStateValue, label: ppStateName });
        else setNState({ value: 0, label: "Select" });
        setNDocument("P");
        setPForexTotal(0);
        setPTotalAmount(0);
        setPCgst(0);
        setPIgst(0);
        setPUgst(0);
        setPSgst(0);
        setPRoundOff(0);
        setPOtherCharges(0);
        setPProduct("CN");
        setPIsd(null);
        setPDenomination("");
        setPQuantity("");
        setPRate("");
        setPProductList([]);
        setPaymentData([]);
        setPIssuer(null);
        setPrPrefix("");
        setPrFrom("");
        setPrTo("");
        setPVtmCardNo("");
        setCommValue("");
        setCommission("");
        setPAgent(null);
        setCommType("F");
        setNManualno(null);
        setNDealer(null);
        setNServiceType("R");

        setPdAccount(null);
        setPdAccountValue(0);
        setPdPaymentType("");

        setPdChequeNum("");
        setPdAmount("");
        setPTaxableVal("");
        setPVtm(null);
        setNArrivalDate(null);
        setNCDFNum(null);
        setCorpServiceCharge(0);
        setPTravellerName('');
        setPIdType("0");
        setPIdNumber("");
        setPidExpiryDate(new Date());
        setPidIssueDate(new Date());
        setEvtmIndividualSrno("");
        setDeletedVtmSrno("");
        setRiskValue("0");
        setAcRemark("");

        setIndividualName("");
        setIndividualPan("");
        setIndividualAddress("");

        setCorporateName("");
        setCorporateAddress("");
        setCorporateGstin("");
        setCorporatePan("");

        setDealerName("");
        setDealerPan("");
        setDealerAddress("");
        setDealerGstin("");
        setTrandate(ymd);
        setNSubExecutive(null);
        setDealerGstin('')
        setIsirn(null);
        setCardNoDoesNotWithIndi('')
    }

    const handleIndiviualChange = (value) => {
        setPPIndividual(value);
    }

    const handleCorporateValue = (value) => {
        setPPCorporate(value);
    }

    const handleLocationChange = (value) => {
        setPPLocation(value);
        var id = value.id;
        var location = id.split("^");
        setPPLocationValue(location[1]);
        setPPStateValue(location[3] == null ? 0 : location[3]);
        setPPStateType(location[4]);
        setPPStateName(location[5] === "" ? "Select" : location[5]);
        setHdrLocation(location[2]);
        setIsBranchDisableForAddNew(location[9]);
        console.log(location[10]);
        setIsAirport(location[10]);
        // console.log("1", location[1], "2", location[3], "3", location[4], "4", location[5], "5", location[2])
        //sessionStorage.activeBranchWithoutHo = location[1];
        sessionStorage.activeBranch = location[1];
        if (location[3] * 1 > 0 && location[3] != null) setNState({ value: location[3], label: location[5] });
        else setNState({ value: 0, label: "Select" });
    }

    const handleNewIndiviualChange = (value) => {
        console.log("New Individual Picklist: ", value);
        setNIndividual(value);
        var id = value.id.split("^");
        setIndividualName(id[3]);
        setIndividualPan(id[4]);
        setNIndivualSrno(id[1]);
        setProfileCnt(id[5]);
        setCntIssue(id[8]);
        setIndividualAddress(id[9])
        setIndividualSelected(1);
        setNCDFNum("");
        setIndividualId(id[10]);
        setIndividualNumber(id[11]);
    }

    const handleNewDealerChange = (value) => {
        setNDealer(value);
        console.log("me andar aa rha hu ")
        Common.callApi(Common.apiTranPP, [sid, "getDealerInfo", JSON.stringify(value)], result => {
            let resp = JSON.parse(result);
            setDealerName(resp.mvli_ledger_legal_name);
            setDealerPan(resp.mvli_pancard);
            setDealerAddress(resp.mvli_address);
            setDealerGstin(resp.mvli_gstin);

        });
        setPAgent(value);
        var id = value.id;
        var del = id.split("^");
        if (isAirport != "1") {
            setNState({ value: del[3], label: del[4] });
        }
    }

    const newIndividual = (btnype) => {
        setShowIndividualForm(true);
        if (btnype === "E" && nIndividual != null) setScrIndividual("E");
        else setScrIndividual("A");
    }

    const cancelConfirm = () => {
        if (scrMode === "A" || scrMode === "E") {
            setMsgTextYN(Common.getMessage("WRN0000"));
            setMsgBoxYN(true);
        } else {
            cancelData();
        }
    }

    // const cancelData = () => {
    //     setMsgBoxYN(false);
    //     setScrMode("");
    // }

    const cancelData = () => {
        setMsgBoxYN(false);
        const sessionData = JSON.parse(sessionStorage.getItem('values'));
        if (sessionData && sessionData.md_type === "PURCHASE") {
            navigate('/individual-profile');
            sessionStorage.removeItem('values');
            sessionStorage.setItem('flag', '1');
        } else {
            setScrMode('');
        }
    }

    const saveData = (issavecorpindividualrisk) => {
        $(".loader").show();
        var totalinr = 0;
        //var isVtmOk = true;
        var isVtmOk = checkEvtmIndividual();
        for (var i = 0; i < paymentData.length; i++) {
            if (nServiceType === "G") {
                if (paymentData[i].tp_payment_type === "CH") {
                    $(".loader").hide();
                    setMsgBox(true);
                    setMsgText("Payment type cannot be Cash in case of service provider.");
                    return;
                }
            }
            if (paymentData[i].tp_payment_type === "RC")
                totalinr -= paymentData[i].tp_amount * 1;
            else totalinr += paymentData[i].tp_amount * 1;
        }
        var msg = [], i = 0;
        var cntcode = 0;
        if (nCountry !== null) {
            var cnt = nCountry.id.split("^");
            cntcode = cnt[1];
        }
        if (nExecutive === null
            || (nServiceType === "R" && (nIndividual === null || nArrivalDate == null))
            || (nServiceType === "G" && nDealer === null)
            // || nPurpose === null
            || nResident === "" || (pTotalAmount != totalinr)
            || (cntcode == 1)
            || (pTotalAmount > 0 && nState.value == 0)
            || (corpServiceCharge > 0 && pOtherCharges < corpServiceCharge)
        ) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (nExecutive == null ? "Executive" : '');
            msg[i++] = ((nServiceType === "R" && nIndividual === null) ? "Individual Profile" : '');
            msg[i++] = ((nServiceType === "G" && nDealer === null) ? "Dealer" : '');
            msg[i++] = ((nServiceType === "R" && nArrivalDate === null) ? "Arrival Date" : '');
            // msg[i++] = (nPurpose == null ? "Purpose" : '');

            msg[i++] = (nResident === "" ? "Residential State" : '');
            msg[i++] = (pTotalAmount != totalinr ? "Total amount of payment must be equal to calculated INR." : "");
            msg[i++] = (cntcode == 1 ? "Country visited can't be India." : "");
            msg[i++] = ((pTotalAmount > 0 && nState.value == 0) ? "Place of supply." : "");
            msg[i++] = ((corpServiceCharge > 0 && pOtherCharges < corpServiceCharge) ? "Other charges can't be less than pre-set service charges." : "");

            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else if (cntcode == 1) {
            $(".loader").hide();
            setMsgText("Visited country can't be India");
            setMsgBox(true);
        } else if (!isVtmOk) {
            $(".loader").hide();
            setMsgText(`Individual: ${nIndivualSrno + ' ' + individualName} is not map with EVTM Card No: ${cardNoDoesNotWithIndi} .`);
            setMsgBox(true);
        } else if (acRemark === '' && issavecorpindividualrisk === true) {
            setShowModal(false);
            setMsgText('Please fill Remark!');
            setMsgBox(true);
            $(".loader").hide();
        } else if (scrMode === 'A' && pProductList.length < 1) {
            setMsgText("Productlist can't be empty.");
            setMsgBox(true);
            $(".loader").hide();
        } else if (nSubExecutive != null && isCommission == "1") {
            setMsgText("In Case of SUB EXECUTIVE you can not add COMMISSION.");
            setMsgBox(true);
            $(".loader").hide();
        } else if (nCorporate && (pTotalAmount * 1) < (pTaxableVal * 1) + (pSgst * 1) + (pIgst * 1) + (pCgst * 1) + (pUgst * 1)) {
            setMsgText("Total Amount should be Greater than Taxable Value+SGST+IGST+CGST+UGST");
            setMsgBox(true);
            $(".loader").hide();
        } else if ((paymentData.filter(p => p?.tp_payment_type === 'PB').length >= 1) && (paymentData.length > 1)) {
            setMsgText("Only one payable allowed.");
            setMsgBox(true);
            $(".loader").hide();
        } else {
            setShowModal(false);
            const obj = {
                srno: hdrSrno,
                ppLocationValue: ppLocationValue,
                nCorporate: nCorporate,
                nIndividual: nIndividual,
                nPurpose: nPurpose,
                nDealer: nDealer,
                nCountry: nCountry,
                nState: nState.value,
                nResident: nResident,
                nEmployeeCode: nEmployeeCode,
                nDocument: nDocument,
                nServiceType: nServiceType,
                ppNewDate: hdrSrno < 1 ? Common.dateYMD(ppNewDate) : hdrDateYmd,
                pForexTotal: pForexTotal,
                pSgst: pSgst,
                pIgst: pIgst,
                pUgst: pUgst,
                pCgst: pCgst,
                pOtherCharges: pOtherCharges === "" || pOtherCharges == null ? 0 : pOtherCharges,
                pRoundOff: pRoundOff,
                pTaxableVal: pTaxableVal === "" ? 0 : pTaxableVal,
                pTotalAmount: pTotalAmount,
                ppStateType: ppStateType,
                ppStateValue: ppStateValue,
                randomString: randomString,
                pProductList: pProductList,
                paymentData: paymentData,
                nRemark1: nRemark1,
                nExecutive: nExecutive,
                nSubExecutive: nSubExecutive,
                nRemark2: nRemark2,
                nCDFNum: nCDFNum,
                nArrivalDate: Common.dateYMD(nArrivalDate),
                nLrsReverse: nLrsReverse,
                nManualNo: nManualNo,

                radioType: radioType,
                ppLocation: ppLocationValue,
                ppCorporate: ppCorporate,
                ppIndividual: ppIndividual,
                // ppNewDate: Common.dateYMD(ppNewDate),
                ppSrnoTo: ppSrnoTo,
                ppSrnoFrom: ppSrnoFrom,
                ppFromDate: Common.dateYMD(ppFromDate),
                ppToDate: Common.dateYMD(ppToDate),
                usdRate: usdRate == "" ? 0 : usdRate,
                billdateymd: hdrDateYmd,
                unlockRequestType: unlockRequestType,
                deletedVtmSrno: deletedVtmSrno,
                issavecorpindividualrisk: issavecorpindividualrisk,
                riskValue: riskValue,
                riskRemark: acRemark,
                cntIssue: cntIssue,
                profileCnt: profileCnt,
                individualName: individualName,
                individualAddress: individualAddress,
                individualId: individualId,
                individualNumber: individualNumber,
                corporateName: corporateName,
                corporateAddress: corporateAddress,
                purpose: nPurpose?.id?.split("^")[1] || 0,
                // dealerGsitn: dealerGsitn
            };
            const infoObject = Common.compareArrays(compareData, [obj]);

            if (+userRight.edit === 1 && scrMode === "E") {
                setTranAuditTrail(Common.addInfoToAuditTrail(tranAuditTrail, infoObject, 'PP', ppLocationValue));
            }
            let msg = "";
            Common.callApi(Common.apiTranPP, [sid, "savedata", JSON.stringify(obj), JSON.stringify(tranAuditTrail)], result => {
                let resp = JSON.parse(result);
                $(".loader").hide();
                if (resp.blacklistedYN?.isBlackListed && +resp.blacklistedYN.isBlackListed === 1) {
                    setMsgText(resp.blacklistedYN.name + " can't saved.Individual/Corporate is Red Flags." + resp.blacklistedYN.tsa_master + " " + resp.blacklistedYN.tsa_data_id + " " + "</br> Contact to compliance department.");
                    setMsgBox(true);
                    return;
                }
                if (resp.msg === "MSG0000") {
                    setPPList(resp.ppList);
                    setScrMode("Q");
                    setKey("INFO");
                    //setIsIrnGenerated(resp.isIrnGenerated);
                    let paramDate = Common.dateYMD(ppNewDate);
                    if (hdrSrno > 0) {
                        paramDate = hdrDateYmd;
                    }
                    fillViewForm(resp.srno, paramDate);
                    //setHdrSrno(resp.srno);
                    if (typeof resp.irn.Status !== "undefined") {
                        if (resp.irn.Status == "0") {
                            msg = ", IRN generation failed.";
                            alert(JSON.stringify(resp.irn.ErrorDetails));
                        }
                    }
                    if (resp.printhtml != "" && +Common.Billprint === 1) {
                        var newWindow = window.open();
                        if (newWindow) {
                            newWindow.document.write(resp.printhtml);
                        }
                    }
                    setMsgBox(true);
                    setMsgText(Common.getMessage(resp.msg) + msg);
                    //setNArrivalDate(null);
                    setTranAuditTrail([]);
                    expireUnlock();
                    setAcRemark("");
                } else if (resp.msg['riskvalue'] === '2') {
                    setShowModal(true);
                    setRiskModalBoxText(resp.msg['ledgername'] + " is medium risk. Please take the extra documentation.");
                    setRiskValue(resp.msg['riskvalue']);
                } else if (resp.msg['riskvalue'] === '3') {
                    setMsgBox(true);
                    setMsgText(resp.msg['ledgername'] + " is high risk.\nTransaction can not be saved.\n Please contact to compliance department.");
                } else {
                    setMsgBox(true);
                    setMsgText(resp.msg);
                }
            });
        }
    }
    // function isCommissionAdded(productList) {
    //     let isCommission = "0";
    //     productList.map((product) => {
    //         if (product.iscommission === '1') {
    //             isCommission = product.iscommission;
    //             return;
    //         }
    //     })
    //     console.log(isCommission);
    //     setIsCommission(isCommission);
    // }
    const expireUnlock = () => {
        if (scrMode == 'E' && unlockRequestType !== "SELF") {
            const obj = {
                srno: hdrSrno,
                type: 'PP',
                status: 'E',
                currentDate: Common.dateYMD(currentDate),
                pageright: 'TRAN_PP'
            }
            Common.callApi(Common.apiUnlockEdit, [sid, 'expireUnlock', JSON.stringify(obj)], (result) => {
                console.log(result);
            });
        }
    }

    const generateIrn = () => {
        const obj1 = {
            coporate: nServiceType === "R" ? nCorporate : nDealer,
            individual: nIndividual,
            location: ppLocationValue,
            billdate: hdrDateYmd,
            hdrsrno: hdrSrno,
            type: 'PP',
            pForexTotal: pForexTotal,
            pSgst: pSgst,
            pIgst: pIgst,
            pUgst: pUgst,
            pCgst: pCgst,
            pOtherCharges: pOtherCharges,
            pRoundOff: pRoundOff,
            pTaxableVal: pTaxableVal === "" ? 0 : pTaxableVal,
            pTotalAmount: pTotalAmount,
            productList: pProductList,
            ppStateType: ppStateType,
            ppStateValue: ppStateValue,
            nState: nState.value,
        }
        $(".loader").show();
        Common.callApi(Common.apiEInvoice, [sid, "generateirn", JSON.stringify(obj1)], result => {
            let resp = JSON.parse(result);
            if (resp.msg != "") {
                $(".loader").hide();
                setMsgBox(true);
                setMsgText(resp.msg);
            } else {
                $(".loader").hide();
                if (resp.irn.Status == "0") {
                    alert(JSON.stringify(resp.irn.ErrorDetails));
                } else {
                    setScrMode("");
                    setMsgBox(true);
                    setMsgText("IRN Generated successfully.");
                }
            }
        });
    }

    const hideIndividualProfile = (val, individualsrno, blacklistedYN, master, dataid, name, idSrno = 0) => {
        setShowIndividualForm(val);
        if (blacklistedYN == '1') {
            setMsgText(name + " saved with Red Flags individual." + master + " " + dataid + "</br>Contact to Compliance Department. ");
            setMsgBox(true);
            setNIndividual(null);
            return;
        }
        if (individualsrno > 0) {
            const obj = {
                individualsrno: individualsrno,
                idSrno: idSrno,
                type: "PURCHASE"
            }
            Common.callApi(Common.apiIndividualProfile, [sid, "individualidfrompicklist", JSON.stringify(obj)], result => {
                let resp = JSON.parse(result);
                console.log("RESPONSE IS  ", resp);
                const desc = resp.desc.split("^");
                if (resp.id === "") setNIndividual(null);
                else handleNewIndiviualChange({ ...resp, desc: `${desc.slice().join("  ^  ")}` });
                // `${desc.slice(0, 3).join(" ")} ^ ${desc[3]} ^ ${desc.slice(4, 7).join(" ")}  ^    ${desc[7]}`
            });
        }
    }

    const handleCorporateChange = (value) => {
        // console.log("Corporate value is:", value);
        setNCorporate(value);
        var id = value.id;
        var corp = id.split("^");
        if (isAirport != "1") {
            setNState({ value: corp[3], label: corp[4] });
        }
        otherChargeChange(corp[8], value);
        setCorpServiceCharge(corp[8] == "" ? 0 : corp[8]);
        setPdPaymentType("");
        setPdAccount(null);
        setCorporateName(corp[11]);
        setCorporatePan(corp[12]);
        setCorporateAddress(corp[15]);
        setCorporateGstin(corp[9]);
    }
    const handleCDFInfo = () => {
        // api call karunga jo ki previous cdf number degi 
        const obj = {
            srno: nIndivualSrno,
            hdrLocation: ppLocationValue

            // srno: hdrsrno,
            // ppLocationValue: location,
            // type: type
        }
        Common.callApi(Common.apiTranPP, [sid, "getCDF", JSON.stringify(obj)], result => {
            var resp = JSON.parse(result);
            // console.log(" tu ye chahta hai", resp);
            if (resp.result === "") {
                alert("Previous CDF Number not found");
                setNCDFNum("");
            } else {
                setNCDFNum(resp.result);

            }

        });


    }

    const handleNewCountry = (v) => {
        setNCountry(v);
    }

    const handleChangeIsd = (value) => {
        setPIsd(value);
        let a = value.id.split("^");
        setPIsdId(a[1]);
        if (nServiceType !== "G") setPAgent(null);
        setCommType("F");
        setCommValue("");
        setCommission("");
        const obj = {
            isd: a[1],
            location: ppLocationValue,
            product: pProduct
        }
        Common.callApi(Common.apiMasterIBR, [sid, "getrate", JSON.stringify(obj)], result => {
            let resp = JSON.parse(result);
            setPRate(resp.buyrate * 1);
            setMaxPRate(resp.maxbuyrate * 1);
            setMinPRate(resp.minbuyrate * 1);
            setUSDRate(resp.usdratebuy * 1);
        });
    }

    const handleProductChange = (v) => {
        setPProduct(v);
        setPIsd(null);
        setPVtm(null);
        setPDenomination("");
        setPRate("");
        setPrFrom("");
        setPVtmCardNo("");
        setPIssuer(null);
        if (v === "EVTM") setPQuantity("1");
        else setPQuantity("");
        Common.callApi(Common.apiIsd, [sid, "ddlistjsonselect", v], result => {
            setIsdOptions(JSON.parse(result));
        });
    }

    const otherChargeChange = (v, corpChangevalue = "") => {
        const obj = {
            tranType: "PP",
            type: "PURCHASE",
            uniquekey: Common.getRandomString(15),
            nState: nState.value,
            pOtherCharges: v === "" ? 0 : v?.trim(),
            ppStateType: ppStateType,
            ppStateValue: ppStateValue,
            nCorporate: corpChangevalue != "" ? corpChangevalue : nCorporate
        }
        Common.validateDecValue(v, setPOtherCharges);
        if (Common.isPurelyNumeric(v.trim())) {
            calcInvoice(pProductList, obj);
        }
    }

    const checkEvtmIndividual = () => {
        var i = 0;
        var isOk = true;
        if (nIndividual !== null) {
            while (i < pProductList.length) {
                if (pProductList[i].prd_product === "EVTM") {
                    var vtmIndividual = pProductList[i].prd_vtm_individual;
                    if (vtmIndividual * 1 > 0 && vtmIndividual != nIndivualSrno) {
                        isOk = false;
                        setCardNoDoesNotWithIndi(pProductList[i].prd_card_no);
                        break;
                    }
                }
                i++;
            }
        }
        return isOk;
    }

    const checkVtmExist = () => {
        var newVtmSrno = pVtm.id.split("^")[1];
        const isVtmExist = pProductList.some(item => {
            var vtmentryexist = item.prd_vtm_num;
            return vtmentryexist == newVtmSrno
        });
        return isVtmExist;
    }

    function idNumberHandler() {
        console.log(pIdType, pIdNumber);
        const idName = pIdType.split('^')[4];
        if (idName === 'PASSPORT') {
            Common.validatePassport(pIdNumber, setPIdNumber)
        } else if (idName === 'AADHAR') {
            Common.validateAdhaar(pIdNumber, setPIdNumber)
        }
    }

    const addProduct = (issaveevtm) => {
        $(".loader").show();
        var msg = [], i = 0;
        var isSaveEvtm = issaveevtm;
        if (
            // (nServiceType === "G" && (pTravellerName === "" || pIdType === "" || pIdType === "0" || pIdNumber === "" || (isIDIssueDate == 1 && new Date(Common.dateYMD(pIdIssueDate)) > new Date(Common.dateYMD(new Date())))
            // || (isIDExpiryDate == 1 && new Date(Common.dateYMD(pIdExpiryDate)) < new Date(Common.dateYMD(new Date())))
            // || (isIDExpiryDate == 1 && isIDIssueDate == 1 && Common.dateIsEqual(pIdExpiryDate, pIdIssueDate)))) ||
            ((pProduct === "CN" || pProduct === "ETC") && pIsd == null || pDenomination === "" || pQuantity === "" || pRate === "" || pRate * 1 === 0)
            || ((pProduct === "ETC" || pProduct === "EVTM") && (prFrom == "" || prTo == "" || pIssuer == null))
            || (+isCommission === 1 && (commType === "" || pAgent === null || commValue === ""))
        ) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (pIsd == null ? "Isd." : '');
            msg[i++] = (pDenomination === '' ? "Denomination." : '');
            msg[i++] = (pQuantity == '' ? "Quantity." : '');
            msg[i++] = (pRate == '' || pRate * 1 === 0 ? "Rate." : '');
            if ((pProduct === "ETC" || pProduct === "EVTM") && (prFrom == "" || prTo == "" || pIssuer == null)) {
                msg[i++] = (pIssuer == null ? "Issuer." : '');
                msg[i++] = (prFrom == '' ? "From." : '');
                msg[i++] = (prTo == '' ? "To." : '');
            }
            /*
            if (nServiceType === "G") {
                msg[i++] = (pTravellerName === '' ? "Traveller Name." : '');
                msg[i++] = (pIdType === '' || pIdType == "0" ? "Id type." : '');
                msg[i++] = (pIdNumber === "" ? "Id Number." : '');
                msg[i++] = (isIDExpiryDate == 1 && (new Date(Common.dateYMD(pIdExpiryDate)) < new Date(Common.dateYMD(new Date()))) ? "Expiry Date can not be earlier than today." : '');
                msg[i++] = (isIDIssueDate == 1 && (new Date(Common.dateYMD(pIdIssueDate)) > new Date(Common.dateYMD(new Date()))) ? "Issue Date can not be later than today." : '');
                msg[i++] = (isIDExpiryDate == 1 && isIDIssueDate == 1 && Common.dateIsEqual(pIdExpiryDate, pIdIssueDate) ? "Issue Date and Expiry Date cannot be same." : '');
            }
            */
            if (+isCommission === 1 && (commType === "" || pAgent === null || commValue === "")) {
                msg[i++] = (pAgent == null ? "Agent." : '');
                msg[i++] = (commType == '' ? "Commission type." : '');
                msg[i++] = (commValue == '' ? "Commission value." : '');
            }
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else if ((pProduct === "ETC" || pProduct === "EVTM") && (prTo * 1 - prFrom * 1 > 100)) {
            $(".loader").hide();
            setMsgText("'To' must be less than 100.");
            setMsgBox(true);
        } else if (maxPRate != 0 && minPRate != 0 && (pRate > maxPRate || pRate < minPRate)) {
            $(".loader").hide();
            msg[i++] = (pRate > maxPRate ? "Maximum rate is " + maxPRate : '');
            msg[i++] = (pRate < minPRate ? "Minimum rate is " + minPRate : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else if (pRate < 0.0001) {
            $(".loader").hide();
            setMsgText(Common.buildMessageFromArray(["Rate should be greater than 0"]));
            setMsgBox(true);
        } else if (pProduct === 'EVTM' && ((pRate * 1) > (dsrRate * 1)) && !isSaveEvtm) {
            $(".loader").hide();
            setMsgTextYNevtm("Do you real want to buy above DER.");
            setMsgBoxYNevtm(true);
        } else {
            $(".loader").hide();
            if (pProduct === "EVTM") {
                if (checkVtmExist()) {
                    setMsgBox(true);
                    setMsgText("Cannot add VTM which is already added.");
                    return;
                }
            }
            var isdarr = pIsd.id.split("^");
            var agentgrp = 0;
            var agentaccnt = 0;
            var agentname = "";
            var issgrp = 0;
            var issaccnt = 0;
            if (pAgent !== null) {
                var agent = pAgent.id.split("^");
                agentgrp = agent[1];
                agentaccnt = agent[2];
                agentname = agent[5];
            }
            if (pIssuer !== null) {
                var issuer = pIssuer.id.split("^");
                issgrp = issuer[1];
                issaccnt = issuer[2];
            }
            var usdAmt = 0;
            if (usdRate != "" && usdRate != 0) {
                usdAmt = (pRate * pQuantity * pDenomination) / usdRate;
            }
            const obj = {
                tranType: "PP",
                //type: "PURCHASE",
                uniquekey: Common.getRandomString(15),
                prd_line_no: productLineNo + 1,
                prd_location: ppLocationValue,
                prd_type: 'PP',
                prd_srno: hdrSrno,
                prd_isd: isdarr[1],
                prd_date: hdrSrno < 1 ? Common.dateYMD(ppNewDate) : hdrDateYmd,
                prd_product: pProduct,
                prd_deno: pDenomination,
                prd_qty: pQuantity,
                prd_rate: pRate,
                prd_amount: Math.round(pRate * pQuantity * pDenomination),
                prd_from: prFrom,
                prd_prefix: prPrefix,
                prd_to: prTo,
                prd_group: issgrp,
                prd_account: issaccnt,
                prd_agent_group: isCommission == "0" ? 0 : agentgrp,
                prd_agent_ledger: isCommission == "0" ? 0 : agentaccnt,
                prd_agent_name: isCommission == "0" ? "" : agentname,
                prd_card_no: pVtmCardNo,
                isd_name: isdarr[2],
                randomString: randomString,
                prd_commission_type: commType,
                prd_commission_value: commValue == "" ? 0 : commValue,
                prd_commission: commission == "" ? 0 : commission,
                nCorporate: nCorporate,
                nState: nState.value,
                pOtherCharges: pOtherCharges,
                ppStateType: ppStateType,
                ppStateValue: ppStateValue,
                scrMode: scrMode,
                prd_vtm_num: pProduct === "EVTM" ? evtmNum : 0,
                pVtm: pVtm,
                prd_usd_rate: usdRate == "" ? 0 : Number(usdRate).toFixed(2),
                prd_usd_amount: Number(usdAmt).toFixed(2),
                isCommission: isCommission,
                delny: "Y",
                prd_traveller_name: pTravellerName,
                prd_id_type: (pIdType == "" || pIdType == "0") ? 0 : pIdType.split('^')[1],
                prd_id_number: pIdNumber,
                prd_id_issue_date: isIDIssueDate == 1 ? Common.dateYMD(pIdIssueDate) : "",
                prd_id_expiry_date: isIDExpiryDate == 1 ? Common.dateYMD(pIdExpiryDate) : "",
                prd_vtm_individual: evtmIndividualSrno
            }
            // var productlist;
            // const isdAlreadyExist = isIsdAlreadyExist(obj);
            // if (isdAlreadyExist.isIsdExist && pProduct === "CN") {
            //     productlist = Common.arrayChangeItem(pProductList, 'prd_line_no', isdAlreadyExist.prdRow.prd_line_no, 'prd_qty', isdAlreadyExist.prdRow.prd_qty);
            //     productlist = Common.arrayChangeItem(pProductList, 'prd_line_no', isdAlreadyExist.prdRow.prd_line_no, 'prd_amount', isdAlreadyExist.prdRow.prd_amount);
            //     productlist = Common.arrayChangeItem(pProductList, 'prd_line_no', isdAlreadyExist.prdRow.prd_line_no, 'prd_usd_amount', isdAlreadyExist.prdRow.prd_usd_amount);
            // } else {
            //     productlist = Common.arrayAddItem(pProductList, obj);
            // }
            var productlist = Common.arrayAddItem(pProductList, obj);
            if (productlist.length > 0) {
                setDisableOtherCharge(false);
            }
            const obj2 = {
                TabType: "Product",
                ALineNo: tranAuditTrail.length + 1,
                AType: "A",
                TLoc: ppLocationValue,
                TType: 'PP',
                Product: pProduct,
                ISD: isdarr[2],
                Deno: pDenomination,
                Quantity: pQuantity,
                Rate: pRate,
                Amount: pRate * pQuantity * pDenomination,
                // ...(pProduct === "ETC" ? {
                ProductFrom: prFrom,
                ProductTo: prTo,
                ProductPrefix: prPrefix,
                ProductGroup: issgrp,
                ProductAccout: issaccnt,
                // } : {}),
                CommsnType: commType,
                AgentGroupCode: agentgrp,
                AgentLedgerCode: agentaccnt,
                CommsnRate: commValue == "" ? 0 : commValue,
                CommsnAmount: commission == "" ? 0 : commission,

            }
            if (+userRight.edit === 1 && scrMode === 'E') {
                setTranAuditTrail(prevtranAuditTrail => [...prevtranAuditTrail, obj2]);
            }
            setPProductList(productlist);
            setCounter(counter + 1);
            setProductLineNo(1 * productLineNo + 1);
            setPIsd(null);
            setPIssuer(null);
            setPDenomination("");
            if (pProduct === "EVTM") setPQuantity("1");
            else setPQuantity("");

            setPRate("");
            setPrPrefix("");
            setPrFrom("");
            setPrTo("");
            setPVtmCardNo("");
            setCommValue("");
            setCommission("");
            if (nServiceType !== "G") setPAgent(null);
            setCommType("F");
            setPVtm(null);
            calcInvoice(productlist, obj);
            setPidExpiryDate(new Date());
            setPidIssueDate(new Date());
            setPIdNumber('');
            setPIdType('');
            setPTravellerName('');
            setEvtmIndividualSrno("");
            setIsIDExpiryDate(0);
            setIsIDIssueDate(0);
            setAgentName("");
            setAgentPan("");
            setAgentAddress("");
        }
    }

    const isIsdAlreadyExist = (obj) => {
        var isIsdExist = false;
        var prdRow = {};
        for (var i = 0; i < pProductList.length; i++) {
            if (pProductList[i].prd_isd === obj.prd_isd && pProductList[i].prd_deno === obj.prd_deno && pProductList[i].prd_product === obj.prd_product) {
                prdRow.prd_line_no = pProductList[i].prd_line_no;
                prdRow.prd_qty = 1 * pProductList[i].prd_qty + obj.prd_qty * 1;
                prdRow.prd_amount = (prdRow.prd_qty * obj.prd_rate * obj.prd_deno).toFixed(2);
                prdRow.prd_usd_amount = (prdRow.prd_amount / usdRate).toFixed(2);
                isIsdExist = true;
                break;
            }
        }
        return { isIsdExist: isIsdExist, prdRow: prdRow };
    }

    const calcInvoice = (productlist, obj) => {
        Common.callApi(Common.apiCalcTaxable, [sid, "calcinvoice", JSON.stringify(productlist), JSON.stringify(obj)], result => {
            let resp = JSON.parse(result);
            setPForexTotal(resp.fxamt);
            setPSgst(resp.sgst);
            setPTotalAmount(resp.totalamt);
            setPTaxableVal(resp.taxablevalue);
            setPRoundOff(resp.roundoff);
            setPCgst(resp.cgst);
            setPIgst(resp.igst);
            setPUgst(resp.ugst);
            var amt = 0;
            for (var i = 0; i < paymentData.length; i++) {
                amt += paymentData[i].tp_amount * 1;
            }
            setPdAmount(1 * resp.totalamt - amt);
        });
    }
    const fillViewCompareObject = (resp) => {
        const desc = resp.corpDesc.split("^")
        const obj2 = {
            nServiceType: resp.service_type,
            nIndividual: resp.ind_id === "^0^0^" ? null : { id: resp.ind_id, label: resp.ind_label, desc: desc.slice().join(" ^ "), },
            nManualNo: resp.manuallabel === "^^^^0^" ? null : { id: resp.manualid, label: resp.manuallabel, },
            nCountry: resp.cntid === "^0^^" ? null : { id: resp.cntid, label: resp.cntlabel },
            nState: resp.state,
            nResident: resp.residential,
            nEmployeeCode: resp.emp_code,
            nRemark1: resp.remark1,
            nCDFNum: resp.cdfnum,
            nRemark2: resp.remark2,
            nArrivalDate: resp.arrivaldate,
            nExecutive: resp.exec_id == null ? null : { id: resp.exec_id, label: resp.exec_label },
            nSubExecutive: (!resp.subExeccutive || resp.subExeccutive == '0') ? null : { id: resp.subExeccutiveId, label: resp.subExeccutiveLabel },
            nCorporate: (resp.acct_id === null && resp.service_type === "G") === null ? null : { id: resp.acct_id, label: resp.acct_label },
            nDealer: (resp.acct_id === null && resp.service_type !== "G") === null ? null : { id: resp.acct_id, label: resp.acct_label },
            nPurpose: resp.purpose == null ? null : { id: resp.purpose, label: resp.purpose_name },
        };
        setCompareData([obj2]);
    }

    const fillViewForm = (hdrsrno, date) => {
        setNArrivalDate("");
        setHdrSrno(hdrsrno);
        setKey('INFO');
        setRandomString("0");
        setPVtm(null);
        setViewDate(date);
        setDeletedVtmSrno("");
        $(".loader").show();
        const obj = {
            srno: hdrsrno,
            ppLocationValue: ppLocationValue,
            type: "PP"
        }
        Common.callApi(Common.apiTranPP, [sid, "viewdata", JSON.stringify(obj)], result => {
            let resp = JSON.parse(result);
            if (resp.msg === "MSG0000") {
                fillViewCompareObject(resp);
                $(".loader").hide();
                const desc = resp.corpDesc.split("^")
                setScrMode("Q");
                if (resp.ind_id === "^0^0^") setNIndividual(null);
                else setNIndividual({ id: resp.ind_id, label: resp.ind_label, desc: `${desc.slice().join(" ^  ")}` });

                if (resp.cntid === "^0^^") setNCountry(null);
                else setNCountry({ id: resp.cntid, label: resp.cntlabel });

                if (resp.manualid == null) setNManualno(null);
                else setNManualno({ id: resp.manualid, label: resp.manuallabel });


                if (resp.arrivaldate != null) setNArrivalDate(new Date(resp.arrivaldate));
                else setNArrivalDate(null);

                if (resp.exec_id === null) setNExecutive(null);
                else setNExecutive({ id: resp.exec_id, label: resp.exec_label });

                if (resp.subExeccutiveId === null) setNSubExecutive(null);
                else setNSubExecutive({ id: resp.subExeccutiveId, label: resp.subExeccutiveLabel });

                if (resp.acct_id === null) {
                    setNCorporate(null);
                    setCorpServiceCharge(0);
                    setNDealer(null);
                } else {
                    if (resp.service_type === "G") {
                        setNDealer({ id: resp.acct_id, label: resp.acct_label });
                        setPAgent({ id: resp.acct_id, label: resp.acct_label });
                        setDealerName(resp.acct_id.split("^")[11]);
                        setDealerPan(resp.acct_id.split("^")[12]);
                        setDealerAddress(resp.acct_id.split("^")[15]);
                        setDealerGstin(resp.acct_id.split("^")[9]);
                        setCorpServiceCharge(resp.acct_id.split("^")[8]);
                    }
                    else setNCorporate({ id: resp.acct_id, label: resp.acct_label });
                    setCorporateName(resp.acct_id.split("^")[11]);
                    setCorporatePan(resp.acct_id.split("^")[12]);
                    setCorporateAddress(resp.acct_id.split("^")[15]);
                    setCorporateGstin(resp.acct_id.split("^")[9]);
                    setCorpServiceCharge(resp.acct_id.split("^")[8]);
                }
                setNEmployeeCode(resp.emp_code);
                setNState({ value: resp.state, label: resp.statename });
                setNIndivualSrno(resp.individualsrno);
                // setNServiceType(resp.service_type);
                // if (resp.service_type === 'G') {
                handleServiceType(resp.service_type);
                // }
                setNResident(resp.residential);
                setNRemark1(resp.remark1);
                setNRemark2(resp.remark2);
                setNLrsReverse(resp.lrsreverse);
                setNCDFNum(resp.cdfnum);
                setNDocument(resp.doc);

                setPForexTotal(resp.forextotal);
                setPCgst(resp.cgst);
                setPSgst(resp.sgst);
                setPIgst(resp.igst);
                setPUgst(resp.ugst);
                setPRoundOff(resp.round_off);
                setPTotalAmount(resp.total_inr);
                setPOtherCharges(resp.other_charge);
                setPTaxableVal(resp.taxablevalue);

                setPProductList(resp.productlist);
                setPaymentData(resp.paydetails);
                setProductLineNo(resp.maxlineno);
                setPaymentLineNo(resp.paymaxlineno * 1);
                setNPurpose({ id: resp.purpose, label: resp.purpose_name });
                setHdrDate(resp.date);
                setHdrLocation(resp.locname);
                setHdrDateYmd(resp.dateymd);

                setIsIrnApplicable(resp.is_irn_applicable);

                setIsIrnGenerated(resp.isIrnGenerated);
                setIsIrnCancelled(resp.isIrnCancelled);
                setIrnCancelDate(resp.irncanceldt);
                setIrnCancelRemarkHdr(resp.irncancelrmk);
                setCancelButtonView(+resp.hdr_cancel_billYN === 1 ? false : true);
                setIndividualName(resp.ind_id.split('^')[3]);
                setIndividualPan(resp.ind_id.split("^")[4]);
                setIndividualAddress(resp.ind_id.split("^")[9])
                setTrandate(resp.ymdDate);
                setIndividualName(resp.individualName);
                setIndividualAddress(resp.individualAddress);
                setCorporateName(resp.ledgerName);
                setCorporateAddress(resp.ledgerAddress);
                setIndividualId(resp.individualIdName);
                setIndividualNumber(resp.individualNumber);
                setIsirn(resp.hdr_isirn);

                // if (resp.accountcode == '0' || resp.accountcode == "") setLdgAllBank(null);
                // else setLdgAllBank({ id: '^' + resp.accountcode + '^' + resp.bank_name + '^', label: resp.accountcode + ' ' + resp.bank_name });
                // setLdgAllBankCode(resp.accountcode);
                // setNAccountNo(resp.accountno);
                // setNIfscCode(resp.accountifsc);


                if (+resp.isIrnGenerated === 1) {
                    setIrnObj({
                        irn: resp.irn,
                        ackdate: resp.ackdate,
                        acknum: resp.ackno,
                        signedqr: resp.signedqr
                    });
                }

                if (!(resp.irncancelreason == null || resp.irncancelreason == "")) {
                    setIrnCancelReasonHdr(Common.getIrnCancelReason.find(item => item.id == resp.irncancelreason).desc);
                }

            }
        });
    }

    const btnEditRequest = () => {
        setIndividualSelected(1);
        const currDate = new Date();
        const newDate = viewDate.split('/');
        const newViewDate = newDate[2] + '-' + newDate[1] + '-' + newDate[0];
        const newCurrDate = Common.dateYMD(currDate);

        const dateA = new Date(newViewDate);
        const dateB = new Date(newCurrDate);

        // Calculate the difference in milliseconds
        const differenceInMilliseconds = dateB - dateA;
        // Convert milliseconds difference to days
        const differenceInDays = Math.ceil(differenceInMilliseconds / (1000 * 3600 * 24));
        // console.log(differenceInDays);
        const obj = {
            srno: hdrSrno,
            type: 'PP',
            pageright: 'TRAN_PP',
            location: ppLocationValue
        }
        // const message = 'unlock'
        Common.callApi(Common.apiUnlockEdit, [sid, 'checkUnlock', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setUnlockRequestType(resp.requestsrc);
            if (Common.editDateLimit == differenceInDays || resp.msg == "unlock") {
                setScrMode('E');
                if (pProductList.length > 0) {
                    setDisableOtherCharge(false);
                }
                if (nArrivalDate != null && nIndividual != null) {
                    setArrivalSelected(1);
                }
            } else {
                setShowEditRequest(true);
                setEditLogObject({ trantype: 'PP', trannumber: hdrSrno, location: ppLocationValue, tranDate: Common.dateYMD(currDate) });
            }
        })
    }

    // const editData = () => {
    //     setScrMode("E");
    //     if (pProductList.length > 0) {
    //         setDisableOtherCharge(false);
    //     }
    // }

    const deleteProduct = (value, vtmNum, product) => {
        const itemToDelete = pProductList.find(item => item.uniquekey === value);
        if (product === "EVTM") {
            var vtm_srno = deletedVtmSrno;
            if (deletedVtmSrno != "") {
                vtm_srno += ",";
            }
            vtm_srno += vtmNum;
            setDeletedVtmSrno(vtm_srno);
        }
        if (itemToDelete) {
            // console.log("inme se dekh ", itemToDelete);
            // Custom keys for the deleted item
            const formattedItem = {
                TabType: "Product",
                ALineNo: tranAuditTrail.length + 1,
                AType: "D",
                // TLine: productLineNo + 1,// item to 
                TLoc: ppLocationValue,
                TType: 'PP',
                Product: itemToDelete.prd_product,
                ISD: itemToDelete.isd_name,
                Deno: itemToDelete.prd_deno,
                Quantity: itemToDelete.prd_qty,
                Rate: itemToDelete.prd_rate,
                Amount: itemToDelete.prd_amount,
                //ETC EXTRA
                // ...(itemToDelete.prd_product === "ETC" ? {
                ProductFrom: itemToDelete.prd_from,
                ProductTo: itemToDelete.prd_to,
                ProductPrefix: itemToDelete.prd_prefix,
                ProductGroup: itemToDelete.prd_group, //prd_group
                ProductAccout: itemToDelete.prd_account,//prd_account
                // } : {}),
                // commision 
                AgentGroupCode: itemToDelete.prd_agent_group,
                AgentLedgerCode: itemToDelete.prd_agent_ledger,
                CommsnType: itemToDelete.prd_commission_type,
                CommsnRate: itemToDelete.prd_commission_value,
                CommsnAmnt: itemToDelete.prd_commission,
            };
            if (+userRight.edit === 1 && scrMode === 'E') {
                setTranAuditTrail(prevtranAuditTrail => [...prevtranAuditTrail, formattedItem]);
            }

        }
        const obj = {
            tranType: "PP",
            type: "PURCHASE",
            uniquekey: Common.getRandomString(15),
            nState: nState.value,
            pOtherCharges: pOtherCharges === "" ? 0 : pOtherCharges,
            ppStateType: ppStateType,
            ppStateValue: ppStateValue,
            nCorporate: nCorporate
        }
        const productlist = Common.arrayRemoveItem(pProductList, "uniquekey", value);
        setPProductList(productlist);
        calcInvoice(productlist, obj);
        setCounter(counter - 1);
    }

    const handleFromChange = (v) => {
        Common.validateNumValue(v, setPrFrom);
        setPrTo((v * 1 + pQuantity * 1) - 1);
        if (pProduct === "EVTM") {
            setPrTo(v);
        }
    }

    const handleDenoChange = (v) => {
        Common.validateDecValue(v, setPDenomination);
        setCommValue(calcCommission(commission, commType, pQuantity, v, pRate));
    }

    const handleQuantityChange = (v) => {
        Common.validateNumValue(v, setPQuantity);
        if (pProduct === "")
            setPrTo((v * 1 + prFrom * 1) - 1);
        setCommValue(calcCommission(commission, commType, v, pDenomination, pRate));
    }

    const handleRateChange = (v) => {
        Common.validateDecValue(v, setPRate);
        setCommValue(calcCommission(commission, commType, pQuantity, pDenomination, v));
        if (pIsd != null) {
            var isdarr = pIsd.id.split("^");
            if (isdarr[1] === "USD") {
                setUSDRate(v);
            }
        }
    }

    const calcCommission = (value, type, quantity, deno, rate) => {
        var comm = 0;
        if (type === "P") {
            comm = (value * quantity * deno) / 100;
        } else if (type === "R") {
            comm = (quantity * deno * rate) * (value / 100);
        } else {
            comm = value;
        }
        if (comm > 0) {
            return comm.toFixed(2);
        }
        return comm;
    }

    const handleAgentChange = (value) => {
        setPAgent(value);
        Common.callApi(Common.apiTranPP, [sid, "getAgentInfo", JSON.stringify(value)], result => {
            let resp = JSON.parse(result);
            setAgentName(resp.mvli_ledger_legal_name);
            setAgentPan(resp.mvli_pancard);
            setAgentAddress(resp.mvli_address);
        });
        setCommType("F");
        /*
        Common.callApi(Common.apiLedger, [sid, "getisdcommission", value.id, pIsdId, pProduct], result => {
            let resp = JSON.parse(result);
            setCommType(resp.type);
            setCommission(resp.value);
            var commvalue;
            if (resp.type === "P" || resp.type === "R") {
                commvalue = calcCommission(resp.value, resp.type, pQuantity, pDenomination, pRate);
            } else {
                commvalue = resp.value;
            }
            setCommValue(commvalue);
        });
        */
    }

    const handleCommissionCalc = (v) => {
        Common.validateDecValue(v, setCommission);
        setCommValue(calcCommission(v * 1, commType, pQuantity, pDenomination, pRate));
    }

    const handleAccountValue = (value) => {
        setPdAccount(value);
        var id = value.id.split("^");
        setPdGroupValue(id[1]);
        setPdAccountValue(id[2]);
    }

    const handlePaymentType = (v) => {
        setDisablePaymentAccount(false);
        setPdPaymentType(v);
        setLdgAllBank(null);
        setLdgAllBankCode("");
        setNAccountNo("");
        setNIfscCode("");
        $(".loader").show();
        setPdAccount(null);
        setPdAccountValue(0);
        setPdChequeNum("");
        var ldgType = "";
        if (v === "") {
            $(".loader").hide();
            return;
        }
        if (v === "CH") {
            ldgType = "CASH";
        } else if (v === "BN" || v === "CQ") {
            ldgType = "BANK";
            setLdgSrchType("BANK");
            $(".loader").hide();
            return;
        } else if (v === "PB") {
            ldgType = "WALKIN";
            if (nServiceType === "G") {
                if (nDealer != null) {
                    setPdAccount(nDealer);
                    const corp = nDealer.id.split('^');
                    setCorpName(corp[5]);
                }
                setDisablePaymentAccount(true);
                $(".loader").hide();
                return;
            }
            if (nCorporate !== null) {
                setPdAccount(nCorporate);
                const corp = nCorporate.id.split('^');
                setCorpName(corp[5]);
                setDisablePaymentAccount(true);
                $(".loader").hide();
                return;
            }
        } else {
            ldgType = "WALKIN";
        }
        setLdgSrchType(ldgType);
        Common.callApi(Common.apiLedger, [sid, "getledgerinfo", ldgType], result => {
            let resp = JSON.parse(result);
            setPdAccount({ id: resp.id, label: resp.label });
            $(".loader").hide();
        });
    }

    const addPayment = () => {
        console.log("Account Valud is :", pdAccount);
        var msg = [], i = 0;
        if (pTotalAmount < 1) {
            msg[i++] = (pTotalAmount < 1 ? "Total amount must be greater than 0." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else if (pdPaymentType === "" || pdAccount === null || pdAmount < 1 || (pdPaymentType === 'CQ' && chequeValue === null) || (pdPaymentType === "BN" && pdChequeNum === "")) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (pdAccount === null ? "Account." : '');
            msg[i++] = (pdPaymentType === "" ? "Payment Type." : '');
            msg[i++] = (pdAmount < 1 ? "Entered amount can't be 0." : '');
            if (pdPaymentType === 'CQ' && chequeValue === null) msg[i++] = (chequeValue === null ? "Select a Cheque." : '');
            if (pdPaymentType === "BN" && pdChequeNum === "") msg[i++] = (chequeValue === null ? "Refernece Number." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else if (pdPaymentType === 'PB' && (ldgAllBankCode === "" || nAccountNo === "" || nIfscCode === "") && (nCorporate === null) && (nDealer === null)) {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (ldgAllBankCode === "" ? " Bank name . " : '');
            msg[i++] = (nAccountNo === "" ? "Account Number ." : '');
            msg[i++] = (nIfscCode === "" ? "IFSC Code . " : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {

            // Check for duplicate reference number if payment type is BN
            if (pdPaymentType === "BN" && pdChequeNum !== "") {
                const isDuplicateRef = paymentData.some(item =>
                    item.tp_payment_type === pdPaymentType &&
                    item.tp_cheque === pdChequeNum
                );
                if (isDuplicateRef) {
                    msg[i++] = `Reference number '${pdChequeNum}' is already used for '${pdPaymentType}.`;
                    setMsgText(Common.buildMessageFromArray(msg));
                    setMsgBox(true);
                    return;
                }
            }

            var grp = 0;
            var accnt = 0;
            var accntname = '';
            if (pdAccount !== null) {
                var a = pdAccount.id.split("^");
                grp = a[1];
                accnt = a[2];
                if (pdPaymentType === "CH" || pdPaymentType === 'PB') {
                    accntname = a[4];
                } else {
                    accntname = a[5];
                }
            }
            let tcbb_srno = 0;
            let tcbb_line_no = 0;
            let tcbb_location = 0;
            let tcbb_from = 0;
            let tcbb_type = '';

            if (pdPaymentType === "CQ") {
                const ch = chequeValue.id.split("^");
                tcbb_srno = ch[1];
                tcbb_line_no = ch[2];
                tcbb_location = ch[3];
                tcbb_from = ch[4];
                tcbb_type = ch[5];
            }
            const obj = {
                uniquekey: Common.getRandomString(10),
                tp_line_no: paymentLineNo + 1,
                tp_location: ppLocationValue,
                tp_srno: hdrSrno,
                randomString: randomString,
                tp_payment_type: pdPaymentType,
                tp_account: accnt,
                tp_group: grp,
                mvli_ledger_name: (((nCorporate !== null && nServiceType === "R") || (nDealer !== null && nServiceType === "G")) && pdPaymentType === 'PB') ? corpName : accntname,
                tp_amount: pdAmount,

                tp_cheque: pdChequeNum,
                tp_type: "PP",
                tcbb_from: chequeNum,
                chequeValue: chequeValue,
                delny: 'Y',
                tcbb_srno: tcbb_srno,
                tcbb_line_no: tcbb_line_no,
                tcbb_location: tcbb_location,
                tcbb_from: tcbb_from,
                tcbb_type: tcbb_type,
                bank_code: ldgAllBankCode,
                accnum: nAccountNo,
                ifsc: nIfscCode,
            };
            // const existingItem = Common.isSamePaymentMethod(obj, paymentData);
            // if (existingItem) {
            //     existingItem.tp_amount = (existingItem.tp_amount * 1 || 0) + (obj.tp_amount * 1 || 0);
            //     existingItem.tcbb_from = chequeNum;
            //     existingItem.tp_cheque = pdChequeNum;
            // } else {
            const paymentdata = Common.arrayAddItem(paymentData, obj);
            setPaymentData(paymentdata);
            const obj2 = {
                TabType: "Payment",
                AType: "A",
                ALineNo: tranAuditTrail.length + 1,
                TLoc: ppLocationValue,
                TType: 'PP',
                PaymentType: pdPaymentType,
                PaymentLedgerCode: accnt,
                PaymentGroupCode: grp,
                PaymentAccountName: accntname,
                PaymentAmount: pdAmount,
                // ...(pdPaymentType == "BN" ? {
                ReferenceNo: pdChequeNum
                // } : {}),
            }
            if (+userRight.edit === 1 && scrMode === 'E') {
                setTranAuditTrail(prevtranAuditTrail => [...prevtranAuditTrail, obj2]);
            }
            // }
            setPdPaymentType("");
            setPaymentLineNo((1 * paymentLineNo) + 1);
            setPdAmount("");
            setPdAccount(null);
            setChequeValue(null);
            setChequeLineNo("");
            setChequeLocation("");
            setChequeSrno("");
            setCounter(counter + 1);
            var amt = 0;
            for (var i = 0; i < paymentData.length; i++) {
                amt += paymentData[i].tp_amount * 1;
            }
            setPdAmount(1 * pTotalAmount - amt);
        }
    }

    const deletePayment = (value) => {
        const obj = {
            srno: hdrSrno,
            location: ppLocationValue,
            type: 'PP',
            payment_line_no: value.tp_line_no
        }
        Common.callApi(Common.apiTranPP, [sid, "shouldDelete", JSON.stringify(obj)], result => {
            let resp = JSON.parse(result);
            if (hdrSrno < 1 || resp.isdeletable == '1') {
                const itemToDelete = paymentData.find(item => item.uniquekey === value.uniquekey);
                if (itemToDelete) {
                    // console.log("inme se dekh payment ka hai ye  ", itemToDelete);
                    // Custom keys for the deleted item
                    const formattedItem = {
                        TabType: "Payment",
                        ALineNo: tranAuditTrail.length + 1,
                        AType: "D",
                        TLine: paymentLineNo + 1,
                        TLoc: ppLocationValue,
                        TType: 'PP',
                        // TNum?
                        PaymentType: itemToDelete.tp_payment_type,
                        PaymentGroupCode: itemToDelete.tp_group,
                        PaymentLedgerCode: itemToDelete.tp_account,
                        PaymentAccountName: itemToDelete.mvli_ledger_name,
                        PaymentAmount: itemToDelete.tp_amount,
                        // ...(itemToDelete.tp_payment_type == "BN" ? {
                        ReferenceNo: itemToDelete.tp_cheque,
                        // } : {}),

                    };
                    if (+userRight.edit === 1 && scrMode === 'E') {
                        setTranAuditTrail(prevtranAuditTrail => [...prevtranAuditTrail, formattedItem]);
                    }
                }
                const paymentdata = Common.arrayRemoveItem(paymentData, "uniquekey", value.uniquekey);
                setPaymentData(paymentdata);
                var amt = 0;
                for (var i = 0; i < paymentdata.length; i++) {
                    amt += paymentdata[i].tp_amount * 1;
                }
                setPdAmount(1 * pTotalAmount - amt);
            } else {
                setMsgBox(true);
                setMsgText("Cannot delete, amount aleady knockedoff.");
            }
        });
        setCounter(counter - 1);
    }

    const commissionTypeChange = (v) => {
        setCommType(v);
        setCommission("");
        setCommValue("");
    }

    const print = (printflag) => {
        $(".loader").show();
        if (isIrnGenerated === "0" && isIrnApplicable === "Y") {
            setMsgText("Irn not generated.");
            $(".loader").hide();
            setMsgBox(true);
        } else {
            const obj = {
                srno: hdrSrno,
                location: ppLocationValue,
                type: 'PP',
                pType: 'PP',
                printFlag: printflag,
                nCorporate: nCorporate,
                individualSrno: nIndivualSrno,
                serviceType: nServiceType,
                nDealer: nDealer,

            }
            Common.callApi(Common.apiPrint, [sid, "print", JSON.stringify(obj)], result => {
                $(".loader").hide();
                var newWindow = window.open();
                newWindow.document.write(result);
            });
        }
    }

    const handleChequeValue = (value) => {
        setChequeValue(value);
        var id = value.id.split("^");
        setChequeSrno(id[1]);
        setChequeLineNo(id[2]);
        setChequeLocation(id[3]);
        setChequeNum(id[4]);
    }

    const handleServiceType = (v) => {
        setNServiceType(v);
        if (v === "R") setNDealer(null);
        else {
            setNIndividual(null);
            setNCorporate(null);
            setPdPaymentType("");
            setPdAccount(null);
            Common.callApi(Common.apiIdtype, [sid, "getIdType"], result => {
                setIdTypeList(JSON.parse(result));
            });
        }
    }

    const handleManualNo = (value) => {
        setNManualno(value);
    }

    const handleExecutiveChange = (value) => {
        setNExecutive(value);
    }
    const handleSubExecutiveChange = (value) => {
        setNSubExecutive(value);
    }

    const switchToPaymentTab = (e) => {
        if (e.key === 'Enter') setKey("PAYMENT");
        else if (e.key === "Tab") {
            e.preventDefault();
            productRef.current.focus();
        }
    }

    const handleVtmValue = (value) => {
        setDsrRate("");
        setPVtm(value);
        var v = value.id.split("^");
        const isdVal = { id: `^${v[2]}^${v[7]}`, label: `${v[2]} ${v[7]}` }
        setPIsd(isdVal);
        setPIssuer({ id: `^${v[3]}^${v[4]}`, label: `${v[3]} ${v[4]}` });
        setPVtmCardNo(v[5]);
        handleFromChange(v[6]);//ref no in vtm encashment
        setPDenomination(v[10]);//encashed value
        handleChangeIsd(isdVal);
        setEvtmNum(v[1]);
        setEvtmIndividualSrno(v[9]);
        const obj = {
            hdrsrno: hdrSrno,
            location: ppLocationValue,
            type: "PP",
            isd: v[2],
            product: 'EVTM',
            billdate: hdrSrno > 0 ? hdrDateYmd : Common.dateYMD(ppNewDate),
            group: v[3],
            account: v[4],
            tve_num: v[1]
        };
        Common.callApi(Common.apiMasterDSR, [sid, "getlatestdsr", JSON.stringify(obj)], result => {
            let resp = JSON.parse(result);
            setDsrRate(resp.dsrrate);
        });
        // handleMinMaxRate(isdVal);
    }

    const handleFaView = () => {
        setShowFaView(true);
        setFaViewObject({ location: ppLocationValue, trannumber: hdrSrno, type: 'PP' });
    }
    const handlePreTransactionInfo = () => {
        $(".loader").show();
        if (!nIndivualSrno) {
            setMsgText("Select Individual First.");
            setMsgBox(true);
        } else {
            const obj = {
                srno: nIndivualSrno
            }
            Common.callApi(Common.apiTranPP, [sid, "getpretran", JSON.stringify(obj)], result => {
                $(".loader").hide();
                setShowPreviousTransactionModal(true);
                let res = JSON.parse(result);
                if (res === "") {
                    alert("Select Individual First ");
                    setPreTransaction("");
                } else {
                    setPreTransaction(res);
                }
            });
        }

    }
    const handleMinMaxRate = () => {
        $(".loader").show();
        var msg = [], i = 0;
        if (pIsd === null) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (pIsd === null ? " Select ISD." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            setShowMinMaxRateModal(true);
            setPIsd(pIsd);
            let a = pIsd.id.split("^");
            setPIsdId(a[1]);//
            setPAgent(null);
            setCommType("F");
            setCommValue("");
            const obj = {
                isd: a[1],
                location: ppLocationValue,
                product: pProduct
            }
            Common.callApi(Common.apiMasterIBR, [sid, "getrate", JSON.stringify(obj)], result => {
                let resp = JSON.parse(result);
                if (resp === "") {
                    alert("Select Individual First ");
                    // setMinMaxRate("");
                    $(".loader").hide();
                } else {
                    if (Array.isArray(resp)) {
                        setMinMaxRate(resp);
                    } else if (resp && typeof resp === 'object') {
                        setMinMaxRate([resp]);
                    }
                    $(".loader").hide();
                }
            });
        }



    }
    const btnActivityLog = () => {
        setShowActivityLog(true);
        setLogObject({ trantype: "PP", trannumber: hdrSrno, trancategory: "T", location: ppLocationValue });
    }
    const handleRateCard = () => {
        const obj = {
            location: ppLocationValue,
            product: filterProduct

        }
        Common.callApi(Common.apiMasterIBR, [sid, 'getratecard', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            const newWindow = window.open('about:blank', '_blank');
            var ratecarddate = resp[0]["mrc_date"];
            newWindow.document.write(`
                <html>
                <head>
                    <title>Rate Card</title>
                    <style>
                    table {
                        width: 100%;
                        border-collapse: collapse;
                    }
                    th, td  {
                        border: 2px solid black;
                        padding: 8px;
                        text-align: left;
                    }
                    th {
                        background-color: #f2f2f2;
                    }
                    .header {
                        display: flex;
                        justify-content: space-between; /* Aligns items to opposite corners */
                        align-items: center; /* Vertically centers items */
                    }
                    .header img {
                        width: 300px; /* Adjust the width as needed */
                        height: auto;
                    }
                    .container{
                    background: aliceblue;
                    padding: 20px;
                    }
                    </style>
                </head>
                <body>
                <div class= "container">
                    <div class="header">
                    <img src="img/logo.png" alt="Rate Card Image" />
                        <div>
                            <h1>Zenith Forex</h1>
                            <p>Card Rate as on ${ratecarddate}<p>
                        </div>
                    </div>
                    <table>
                    <thead>
                        <tr>
                        <th>Code</th>
                        <th>Currencies</th>
                        <th>Product</th>
                        <th>Purchase Rate</th>
                        <th>Max Purchase Rate</th>
                        <th>Min Purchase Rate</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${resp.map((item) => `
                        <tr>
                            <td>${item.mrc_isd}</td>
                            <td>${item.isd_name}</td>
                            <td>${item.mrc_product === "C" ? "CN" : item.mrc_product === "R" ? "Card" : item.mrc_product === "D" ? "DD" : item.mrc_product === "T" ? "TT" : ""}</td>
                            <td>${item.mrc_buy_rate}</td>
                            <td>${item.mrc_max_buyrate}</td>
                            <td>${item.mrc_min_buyrate}</td>
                        </tr>
                        `).join('')}
                    </tbody>
                    </table>
                </div>
                </body>
                </html>

              `);

            newWindow.document.close(); // 
        });
    }

    const handleShowCommissionDetail = () => {
        setShowCommissionDetail(true);
    }

    const cancelBillFinalModal = () => {
        setMsgBoxCancelBill(true);
        setIrnCancelDeclaration(false);
        setMsgTextCancelBill("Alert!");
        setIrnCancelReason("");
        setIrnCancelLabel("I confirm the deletion of this bill.");
        setIrnCancelReasonSelect("");
    }

    const cancelBill = () => {
        const obj1 = {
            hdrSrno: hdrSrno,
            location: ppLocationValue,
            type: 'PP',
            irnObj: irnObj,
            irnCancelReason: irnCancelReason,
            irnCancelReasonSelect: irnCancelReasonSelect
        }
        var msg = [];
        var i = 0;
        if (irnCancelReasonSelect === "" || irnCancelReason === "" || !irnCancelDeclaration) {
            setMsgBoxCancelBill(false);
            msg[i++] = (irnCancelReasonSelect === "" ? "Select reason." : "");
            msg[i++] = (irnCancelReason === "" ? "Fill reason." : "");
            msg[i++] = (!irnCancelDeclaration ? "Please check declaration." : "");
            setMsgBox(true);
            setMsgText(Common.buildMessageFromArray(msg));
            return;
        }
        $(".loader").show();
        Common.callApi(Common.apiEInvoice, [sid, 'cancelirn', JSON.stringify(obj1)], result => {
            $(".loader").hide();
            setMsgBoxCancelBill(false);
            let resp = JSON.parse(result);
            if (resp.Status == "2") {
                setMsgBox(true);
                setMsgText(resp.msg);
            } else {
                if (resp.Status == "1") {
                    setScrMode("");
                    setMsgBox(true);
                    setMsgText("IRN cancelled successfully, Cancel Date " + resp.Data.CancelDate);
                } else {
                    alert(JSON.stringify(resp.ErrorDetails));
                }
            }
        });
    }

    const handleIdTypeChange = (value) => {
        var id = value.id.split("^");
        setPIdType(id[1]);
    }

    function handleIdType(val) {
        setPIdType(val);
        setPIdNumber('');
        setIsIDIssueDate(val.split('^')[3]);
        setIsIDExpiryDate(val.split('^')[2]);
    }

    const resetCorporate = () => {
        setNCorporate(null);
        setPdPaymentType("");
        setPdAccount(null);
        setCorporateName("");
        setCorporatePan("");
        setCorporateAddress("");
        setCorporateGstin("");
        setNState({ value: ppStateValue, label: ppStateName });
    }

    const changeDateModal = () => {
        var isOk = true;
        var msg = [], i = 0;
        // if (pProductList.length > 0) {
        //     isOk = false;
        //     msg[i++] = "Please empty Product List.";
        // }
        // if (paymentData.length > 0) {
        //     isOk = false;
        //     msg[i++] = "Please empty Payment List.";
        // }

        if (isOk) {
            setOpenDateChangeModal(true);
            setChangeDateObj(
                {
                    type: "PP",
                    srno: hdrSrno,
                    location: ppLocationValue,
                    right: "TRAN_PP",
                    oldDate: hdrDate,
                    billdate: hdrDate,
                    billdateymd: hdrDateYmd,
                    oldDateymd: hdrDateYmd,
                    productList: pProductList,
                    arrivalDate: Common.dateYMD(nArrivalDate),
                    arrivaldate: Common.dateYMD(nArrivalDate),
                    nCDFNum: nCDFNum,
                    nServiceType: nServiceType,
                    nIndividual: nIndividual,
                    ppLocationValue: ppLocationValue,
                    pProductList: pProductList,
                    usdRate: usdRate,
                    paymentData: paymentData,
                    ppNewDate: viewDate
                }

            );
        } else {
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        }
    }
    const handleCancelBill = () => {
        setIndividualSelected(1);
        const currDate = new Date();
        const newDate = viewDate.split('/');
        const newViewDate = newDate[2] + '-' + newDate[1] + '-' + newDate[0];
        const newCurrDate = Common.dateYMD(currDate);

        const dateA = new Date(newViewDate);
        const dateB = new Date(newCurrDate);

        // Calculate the difference in milliseconds
        const differenceInMilliseconds = dateB - dateA;
        // Convert milliseconds difference to days
        const differenceInDays = Math.ceil(differenceInMilliseconds / (1000 * 3600 * 24));
        // console.log(differenceInDays);
        const obj = {
            srno: hdrSrno,
            type: 'PP',
            pageright: 'TRAN_PP',
            location: ppLocationValue
        }
        // const message = 'unlock'
        Common.callApi(Common.apiUnlockEdit, [sid, 'checkUnlock', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setUnlockRequestType(resp.requestsrc);
            if (Common.editDateLimit == differenceInDays || resp.msg == "unlock") {
                setMsgTextYNBillDelete("Are you sure.");
                setMsgBoxYNBillDelete(true);
            } else {
                setShowEditRequest(true);
                setEditLogObject({ trantype: 'PP', trannumber: hdrSrno, location: ppLocationValue, tranDate: Common.dateYMD(currDate) });
            }
        })


    }
    const handleDeleteBill = (remark) => {
        setMsgBoxYNBillDelete(false);
        const obj = {
            type: 'PP',
            location: ppLocationValue,
            srno: hdrSrno,
            productList: pProductList,
            paymentList: paymentData,
            remark: remark,
        }
        Common.callApi(Common.apideletebill, [sid, 'deletebill', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            if (resp.err == "") {
                setScrMode("");
                listPPdata();
                setMsgText(resp.msg);
                setMsgBox(true);
            } else {
                setMsgText(resp.msg);
                setMsgBox(true);
            }
        })
    }

    const handleAddEVtm = () => {
        setMsgBoxYNevtm(false);
        addProduct(true);
    }

    const exclusiveGSTHandler = () => {
        setOtherChargesInputVisibility(true);
    }

    const gstExclusiveHandler = (v) => {
        setPExclusiveGst(v)
        const val = (v * 100) / 118;
        const roundVal = Math.round(val * 100) / 100;
        otherChargeChange(roundVal + '')
    }

    const handleSetIsCommission = (value) => {
        setIsCommission(value);
        if (nServiceType !== "G") {
            setPAgent(null)
        };
        setCommType("F");
        setCommValue("");
        setCommission("");
    }

    // const showConfirm = () => {
    //     setMsgTextYN("Are you sure you want to change status?");
    //     setMsgBoxYN(true);
    //     return true;
    // };

    const handleAllBankChange = (value) => {
        setLdgAllBank(value);
        const allbank = value.id.split('^');
        setLdgAllBankCode(allbank[1]);
    }

    const handleNextBill = () => {
        const obj = {
            location: ppLocationValue,
            type: "PP",
            srno: hdrSrno,
            hdr_tran_source: ""

        };
        Common.callApi(Common.apiCommom, [sid, "Nextbillexists", JSON.stringify(obj)], result => {
            const resp = JSON.parse(result);
            console.log(resp);
            if (resp.srno) {
                fillViewForm(resp.srno, resp.date);
            } else {
                setMsgText("No next bill available.");
                setMsgBox(true);
            }
        });
    }


    const irnPauseHand = async () => {
        $(".loader").show();

        const obj = {
            location: ppLocationValue,
            hdrsrno: hdrSrno,
            type: 'PP',
        };

        Common.callApi(Common.apiTranPP, [sid, "irn_pause", JSON.stringify(obj)], result => {
            $(".loader").hide();
            let res = JSON.parse(result);
            if (res.status) {
                setScrMode("");
            }
            setMsgText(res.message);
            setMsgBox(true);

        });
    }

    const handlePrevBill = () => {
        const obj = {
            location: ppLocationValue,
            type: "PP",
            srno: hdrSrno,
            hdr_tran_source: ""
        };
        Common.callApi(Common.apiCommom, [sid, "Prebillexists", JSON.stringify(obj)], result => {
            const resp = JSON.parse(result);
            console.log(resp);
            if (resp.srno) {
                fillViewForm(resp.srno, resp.date);
            } else {
                setMsgText("No previous bill available.");
                setMsgBox(true);
            }
        });
    }

    return (

        <>
            {
                showIndividualForm ?
                    <Master_individual_profile reqObj={{ nIndivual: nIndividual, scrIndividual: scrIndividual }} value="TRAN_PP" hideIndividualProfile={hideIndividualProfile} />
                    :
                    <>
                        <LoginHeader />
                        <Menu />
                        <Container fluid>
                            <Row>
                                <Col>
                                    <h2>Purchase From Public</h2>
                                </Col>
                            </Row>
                            {
                                scrMode === "" ?
                                    <>
                                        <Row className='mt-10'>
                                            <Col className='col-md-6 col-12'>
                                                <Form.Group>
                                                    <Row>
                                                        <Col>
                                                            <Form.Check checked={radioType === "N"} onChange={() => setRadioType("N")} type='radio' label="New" />
                                                        </Col>
                                                        <Col>
                                                            <Form.Check checked={radioType === "S"} onChange={() => setRadioType("S")} type='radio' label="SrNo" />
                                                        </Col>
                                                        <Col>
                                                            <Form.Check checked={radioType === "D"} onChange={() => setRadioType("D")} type='radio' label="Date" />
                                                        </Col>
                                                        <Col>
                                                            <Form.Check checked={radioType === "I"} onChange={() => setRadioType("I")} type='radio' label="Individual" />
                                                        </Col>
                                                        <Col>
                                                            <Form.Check checked={radioType === "C"} onChange={() => setRadioType("C")} type='radio' label="Corporate" />
                                                        </Col>
                                                        <Col>
                                                            <Form.Check checked={radioType === "M"} onChange={() => setRadioType("M")} type='radio' label="Manual No." />
                                                        </Col>
                                                        <Col>
                                                            <Form.Check checked={radioType === "R"} onChange={() => setRadioType("R")} type='radio' label="Rate Card." />&nbsp;
                                                        </Col>
                                                    </Row>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>Location<span className="colorThemeRed">*</span></Form.Label>
                                                    <AsyncSelect
                                                        cacheOptions={false}
                                                        defaultOptions={false}
                                                        value={ppLocation}
                                                        getOptionLabel={e => e.label + ' '}
                                                        getOptionValue={e => e.id}
                                                        loadOptions={Picklist.fetchLocationAllowedWithoutHoPicklist}
                                                        onInputChange={Picklist.handleInputChange}
                                                        onChange={handleLocationChange}
                                                        isDisabled={branchDisable === "true"}
                                                    >
                                                    </AsyncSelect>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            {
                                                radioType === "N" ?
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>Date</Form.Label>
                                                            <DatePicker className="form-control"
                                                                selected={ppNewDate}
                                                                onChange={(date) => setPPNewDate(date)}
                                                                dateFormat="dd/MM/yyyy"
                                                                showYearDropdown
                                                                showMonthDropdown
                                                                useShortMonthInDropdown
                                                                dropdownMode="select"
                                                                peekNextMonth
                                                                customInput={
                                                                    <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                                }
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    : radioType === "S" ?
                                                        <>
                                                            <Col className='col-md-3 col-6'>
                                                                <Form.Group>
                                                                    <Form.Label>From<span className="colorThemeRed">*</span></Form.Label>
                                                                    <Form.Control type='text' maxLength={10} value={ppSrnoFrom} onChange={e => Common.validateNumValue(e.target.value, setPPSrnoFrom)} />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col className='col-md-3 col-6'>
                                                                <Form.Group>
                                                                    <Form.Label>To<span className="colorThemeRed">*</span></Form.Label>
                                                                    <Form.Control type='text' maxLength={10} value={ppSrnoTo} onChange={e => Common.validateNumValue(e.target.value, setPPSrnoTo)} />
                                                                </Form.Group>
                                                            </Col>
                                                        </>
                                                        : radioType === "D" || radioType === "I" || radioType === "C" ?
                                                            <>
                                                                {
                                                                    radioType === "I" ?
                                                                        <Col className="col-md-6 col-12">
                                                                            <Form.Group>
                                                                                <Form.Label>Individual Profile<span className="colorThemeRed">*</span></Form.Label>
                                                                                <AsyncSelect
                                                                                    cacheOptions={false}
                                                                                    defaultOptions={false}
                                                                                    value={ppIndividual}
                                                                                    getOptionLabel={e => e.label + ' '}
                                                                                    getOptionValue={e => e.id}
                                                                                    loadOptions={(search) => Picklist.fetchIndividualPicklist(search)}
                                                                                    onInputChange={Picklist.handleInputChange}
                                                                                    onChange={handleIndiviualChange}
                                                                                    formatOptionLabel={Picklist.formatOptionLabel}
                                                                                    components={{ Menu: Picklist.menu }}
                                                                                >
                                                                                </AsyncSelect>

                                                                            </Form.Group>
                                                                        </Col>
                                                                        : null
                                                                }
                                                                {
                                                                    radioType === "C" ?
                                                                        <Col className="col-md-6 col-12">
                                                                            <Form.Group>
                                                                                <Form.Label>Corporate<span className="colorThemeRed">*</span></Form.Label>
                                                                                <AsyncSelect
                                                                                    cacheOptions={false}
                                                                                    defaultOptions={false}
                                                                                    value={ppCorporate}
                                                                                    getOptionLabel={e => e.label + ' '}
                                                                                    getOptionValue={e => e.id}
                                                                                    loadOptions={(search) => Picklist.fetchLedgerPicklistByType(search, 'CORPORATE', ppLocationValue)} // location = 1 , 2
                                                                                    onInputChange={Picklist.handleInputChange}
                                                                                    onChange={handleCorporateValue}
                                                                                >
                                                                                </AsyncSelect>
                                                                            </Form.Group>
                                                                        </Col>
                                                                        : null
                                                                }
                                                                <Col className='col-md-3 col-6'>
                                                                    <Form.Group>
                                                                        <Form.Label>From<span className="colorThemeRed">*</span></Form.Label>
                                                                        <DatePicker className="form-control"
                                                                            selected={ppFromDate}
                                                                            onChange={(date) => setPPFromDate(date)}
                                                                            dateFormat="dd/MM/yyyy"
                                                                            showYearDropdown
                                                                            showMonthDropdown
                                                                            useShortMonthInDropdown
                                                                            dropdownMode="select"
                                                                            peekNextMonth
                                                                            customInput={
                                                                                <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                                            }
                                                                        />
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col className='col-md-3 col-6'>
                                                                    <Form.Group>
                                                                        <Form.Label>To<span className="colorThemeRed">*</span></Form.Label>
                                                                        <DatePicker className="form-control"
                                                                            selected={ppToDate}
                                                                            onChange={(date) => setPPToDate(date)}
                                                                            dateFormat="dd/MM/yyyy"
                                                                            showYearDropdown
                                                                            showMonthDropdown
                                                                            useShortMonthInDropdown
                                                                            dropdownMode="select"
                                                                            peekNextMonth
                                                                            customInput={
                                                                                <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                                            }
                                                                        />
                                                                    </Form.Group>
                                                                </Col>
                                                            </> : radioType === 'M' ?
                                                                <>
                                                                    <Col className='col-md-3 col-6'>
                                                                        <Form.Group>
                                                                            <Form.Label>Manual No.<span className="colorThemeRed">*</span></Form.Label>
                                                                            <Form.Control type='text' maxLength={50} value={ppManualNo} onChange={e => Common.validateAlpNumValue(e.target.value, setPPManualNo)}
                                                                                placeholder='Manual No.' />
                                                                        </Form.Group>
                                                                    </Col>
                                                                </> : radioType === 'R' ?
                                                                    <>
                                                                        <Col className='col-md-3 col-6'>
                                                                            <Form.Group>
                                                                                <Form.Label>Product<span className="text-danger">*</span></Form.Label>
                                                                                <Form.Select value={filterProduct} onChange={e => setFilterProduct(e.target.value)}
                                                                                    required>
                                                                                    <option value="C">CN</option>
                                                                                    <option value="R">Card</option>
                                                                                    <option value="T">TT</option>
                                                                                    <option value="D">DD</option>
                                                                                </Form.Select>
                                                                            </Form.Group>
                                                                        </Col>
                                                                    </> : null
                                            }
                                        </Row>
                                        <Row>&nbsp;</Row>
                                        <Row>
                                            <Col>
                                                {
                                                    +userRight.query === 1 && (radioType !== "N" && radioType !== "R") ?
                                                        <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => listPPdata()}>List</Button> : null
                                                }
                                                &nbsp;
                                                {
                                                    +userRight.add === 1 && radioType === "N" ?
                                                        <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={() => addNewForm()}>Add New</Button> : null
                                                }
                                                &nbsp;
                                                {
                                                    +userRight.add === 1 && radioType === "R" ?
                                                        <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={() => handleRateCard()}>Get Rate</Button> : null
                                                }
                                            </Col>
                                        </Row>
                                        <Row>&nbsp;</Row>
                                        {radioType !== 'R' ?
                                            <Row>
                                                <Table responsive striped>
                                                    <thead>
                                                        <tr>
                                                            <th>&nbsp;</th>
                                                            {/* <th>Type</th>
                                                        <th>Service</th> */}
                                                            <th>Sr No</th>
                                                            <th>Date</th>
                                                            <th>Manual No.</th>
                                                            <th>Individual</th>
                                                            <th>Dealer/Corporate</th>
                                                            <th>Amount</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            ppList.map((item, index) => (
                                                                <tr key={index}>
                                                                    <td>
                                                                        <span onClick={() => fillViewForm(item.hdr_srno, item.new_date)} className='pointer colorThemeBlue'>
                                                                            <FontAwesomeIcon icon={faEye} />
                                                                        </span>
                                                                    </td>
                                                                    {/* <td>{item.hdr_type}</td>
                                                                <td>{item.hdr_service_type === "R" ? "Retail" : item.hdr_service_type === "G" ? "Goods and Service Provider" : ""}</td> */}
                                                                    <td>{item.hdr_srno}</td>
                                                                    <td>{item.hdr_date}</td>
                                                                    <td>{item.hdr_manual}</td>
                                                                    <td>{item.bd_first_name + ' ' + item.bd_middle_name + ' ' + item.bd_last_name}</td>
                                                                    <td>{item.mvli_ledger_name}</td>
                                                                    <td>{item.hdr_total_inr}</td>
                                                                </tr>
                                                            ))
                                                        }
                                                    </tbody>
                                                </Table>
                                            </Row> : null}
                                    </>
                                    :
                                    <>
                                        <Row style={{ display: "none" }}>
                                            <Col>
                                                <p>{randomString}</p>
                                            </Col>
                                        </Row>
                                        <Row style={{ display: (hdrSrno < 1 || isIrnApplicable === "N") && "none" }}>
                                            <Col>
                                                {
                                                    +isIrnCancelled === 1 ?
                                                        <div className='d-flex align-items-baseline'>
                                                            <p><span style={{ color: "red" }}><FontAwesomeIcon icon={faCircleXmark} /></span> <b>Bill Deleted</b></p>
                                                            <p className='mx-2'>Delete Date : <b>{irnCancelDate}</b></p>
                                                            <p className='mx-2'>Reason of Deletion: <b>{irnCancelReasonHdr}</b></p>
                                                            <p className='mx-2'>Deletion Remark: <b>{irnCancelRemarkHdr}</b></p>
                                                        </div>
                                                        :
                                                        <>
                                                            {
                                                                +isIrnGenerated === 1 ?
                                                                    <div className='d-flex align-items-baseline'>
                                                                        <p><span style={{ color: "green" }}><FontAwesomeIcon icon={faCircleCheck} /></span> <b>IRN Generated</b></p>
                                                                        {
                                                                            +userRight.delete === 1 &&
                                                                            <Badge className='mx-2 pointer' bg='danger' onClick={cancelBillFinalModal}>Delete Bill</Badge>
                                                                        }
                                                                    </div>
                                                                    :
                                                                    <div className='d-flex align-items-baseline'>
                                                                        <p><span style={{ color: "red" }}><FontAwesomeIcon icon={faCircleXmark} /></span> <b>IRN Generation Failed</b></p>
                                                                        {
                                                                            (+userRight.delete === 1 && scrMode === "Q") &&
                                                                            <Badge className='mx-2 pointer' bg='warning' onClick={generateIrn}>Generate</Badge>
                                                                        }
                                                                    </div>
                                                            }
                                                        </>
                                                }
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Button variant='outline-danger' size='sm' className='buttonStyle' onClick={() => cancelConfirm()}>Back</Button>
                                                &nbsp;
                                                {
                                                    (+userRight.edit === 1 && scrMode === 'Q' && cancelButtonView) ? <>
                                                        <Button style={{ display: +isIrnGenerated === 1 && "none" }} variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                            btnEditRequest()}>Edit</Button>&nbsp;
                                                    </> : null
                                                }
                                                {
                                                    (+userRight.edit === 1 && scrMode === 'E') || (+userRight.add === 1 && scrMode === 'A') ? <>
                                                        <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => saveData(false)}>Save</Button>&nbsp;
                                                    </> : null
                                                }
                                                {
                                                    (+userRight.query === 1 && scrMode === "Q") ? <>
                                                        {
                                                            +Common.Billprint === 1 &&
                                                            <>
                                                                <Button variant="outline-success" className='buttonStyle divHide' size="sm" onClick={() => print("D")}>With Deno</Button>&nbsp;
                                                                <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={() => print("")}>Without Deno</Button>&nbsp;
                                                            </>
                                                        }
                                                        <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={() => handleFaView()}>Fa View</Button>&nbsp;
                                                        {(+userRight.query === 1 && scrMode === 'Q') ? <>
                                                            <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                                btnActivityLog()}>Activity Log</Button>&nbsp;
                                                        </> : null
                                                        }
                                                    </> : null
                                                }
                                                {
                                                    (scrMode === "Q" && +userRight.add === 1) &&
                                                    < Button variant="outline-secondary" className='buttonStyle' size="sm" onClick={() => addNewForm()}>Add New</Button>
                                                }
                                                {
                                                    (scrMode === "Q" && +userRight.delete === 1) &&
                                                    <>
                                                        &nbsp;
                                                        {+dateChangeRight?.query === 1 &&
                                                            <Button variant="outline-danger" className='buttonStyle' size="sm" onClick={() => changeDateModal()}>Date Change</Button>}
                                                    </>
                                                }
                                                {
                                                    (scrMode === "Q" && +userCancelBillRight.query === 1 && cancelButtonView) &&
                                                    <>
                                                        &nbsp;
                                                        <Button variant="outline-danger" className='buttonStyle' size="sm" onClick={() => handleCancelBill()}>Cancel Bill</Button>
                                                    </>
                                                }
                                                {
                                                    (scrMode === "Q" && +userRight.query === 1) &&
                                                    <>
                                                        &nbsp;
                                                        <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={() => handlePrevBill()}>Prev Bill</Button>
                                                    </>
                                                }
                                                {
                                                    (scrMode === "Q" && +userRight.query === 1) &&
                                                    <>
                                                        &nbsp;
                                                        <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={() => handleNextBill()}>Next bill</Button>
                                                    </>
                                                }
                                            </Col>
                                        </Row>
                                        <Row>&nbsp;</Row>
                                        <Row>
                                            <Col>
                                                {scrMode === 'Q' && +irnPauseRight?.query === 1 && nCorporate !== null && (
                                                    <Badge className='mx-2 pointer' bg='success' onClick={irnPauseHand}>IRN PAUSE</Badge>
                                                )}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col className='col-md-3 col-6'>
                                                <Form.Label>Serial Number : {hdrSrno}</Form.Label>
                                            </Col>
                                            <Col className="col-md-2 col-4">
                                                <span>Location : <b>{hdrLocation} </b></span>
                                            </Col>
                                            <Col className="col-md-2 col-4">
                                                <span>Date : <b>{hdrDate}</b></span>
                                            </Col>
                                            <Col className='ppCharges'>
                                                <span><b>Forex Total (INR): {pForexTotal}</b></span>
                                                &nbsp;
                                                <span><b>Total Amount (INR): {pTotalAmount}</b></span>
                                            </Col>
                                        </Row>
                                        <Row>&nbsp;</Row>
                                        <Tabs activeKey={key} defaultActiveKey="INFO" onSelect={k => handleTabChange(k)}>
                                            <Tab eventKey="INFO" title="Info">
                                                <Row>
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>Service Type</Form.Label>
                                                            <Form.Select disabled={scrMode === "Q"} value={nServiceType} onChange={e => handleServiceType(e.target.value)}>
                                                                <option value="R">Retail</option>
                                                                <option value="G">Good and Service Provider</option>
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Label>Executive<span className="colorThemeRed">*</span></Form.Label>
                                                        <AsyncSelect
                                                            cacheOptions={false}
                                                            defaultOptions={false}
                                                            value={nExecutive}
                                                            getOptionLabel={e => e.label + ' '}
                                                            getOptionValue={e => e.id}
                                                            loadOptions={Picklist.fetchExecutivePicklist}
                                                            onInputChange={Picklist.handleInputChange}
                                                            onChange={handleExecutiveChange}
                                                            isDisabled={scrMode === "Q"}
                                                        >
                                                        </AsyncSelect>
                                                    </Col>
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Label>Sub Executive</Form.Label>
                                                        <AsyncSelect
                                                            cacheOptions={false}
                                                            defaultOptions={false}
                                                            value={nSubExecutive}
                                                            getOptionLabel={e => e.label + ' '}
                                                            getOptionValue={e => e.id}
                                                            loadOptions={Picklist.fetchSubExecutivePicklist}
                                                            onInputChange={Picklist.handleInputChange}
                                                            onChange={handleSubExecutiveChange}
                                                            isDisabled={scrMode === "Q"}
                                                        >
                                                        </AsyncSelect>
                                                    </Col>

                                                    {
                                                        nServiceType === "R" ?
                                                            <>
                                                                <Col className="col-md-12">
                                                                    <Form.Group>
                                                                        <Form.Label>Individual Profile<span className="colorThemeRed">*</span>
                                                                            {
                                                                                scrMode === "Q" ? null :
                                                                                    <>
                                                                                        <span className='tranNewFormText' onClick={() => newIndividual("A")}>Not in list? Create New</span>
                                                                                        &nbsp;&nbsp;
                                                                                        <span className='tranNewFormText' onClick={() => newIndividual("E")}>Edit</span>&nbsp;
                                                                                        {+createIndivisualByPassport?.query === 1 && <span className='tranNewFormText' onClick={() => showPassportForm()}>Add Passport</span>}
                                                                                    </>
                                                                            }{individualSelected === 1 ?
                                                                                <span style={{ display: scrMode === "Q" && "none" }} className="mx-2" onClick={handlePreTransactionInfo}><Badge bg="secondary">Previous Transaction</Badge></span> : null
                                                                            }
                                                                        </Form.Label>
                                                                        <AsyncSelect
                                                                            cacheOptions={false}
                                                                            defaultOptions={false}
                                                                            value={nIndividual}
                                                                            getOptionLabel={e => e.label + ' '}
                                                                            getOptionValue={e => e.id}
                                                                            loadOptions={Picklist.fetchIndividualPicklist}
                                                                            onInputChange={Picklist.handleInputChange}
                                                                            onChange={handleNewIndiviualChange}
                                                                            isDisabled={scrMode === "Q"}
                                                                            formatOptionLabel={Picklist.formatOptionLabel}
                                                                            components={{ Menu: Picklist.menu }}
                                                                        >
                                                                        </AsyncSelect>
                                                                    </Form.Group>
                                                                </Col>
                                                                <Row>
                                                                    <Col className='col-md-3 col-3'>
                                                                        <Form.Label>Name : <b>{individualName}</b></Form.Label>
                                                                    </Col>
                                                                    <Col className="col-md-2 col-3">
                                                                        <span>Pan : <b>{individualPan} </b></span>
                                                                    </Col>
                                                                    <Col className="col-md-7 col-6">
                                                                        <span>Address : <b>{individualAddress}</b></span>
                                                                    </Col>
                                                                </Row>
                                                            </>

                                                            :
                                                            <>
                                                                <Col className="col-md-12">
                                                                    <Form.Group>
                                                                        <Form.Label style={{ display: "flex", alignItems: "center" }}>
                                                                            <span>Dealer<span className="colorThemeRed">*</span></span>
                                                                            <span style={{ display: scrMode === "Q" && "none" }} className="mx-2" onClick={() => setNDealer(null)}><Badge bg="secondary">Reset</Badge></span>
                                                                        </Form.Label>
                                                                        <AsyncSelect
                                                                            cacheOptions={false}
                                                                            defaultOptions={false}
                                                                            value={nDealer}
                                                                            getOptionLabel={e => e.label + ' '}
                                                                            getOptionValue={e => e.id}
                                                                            loadOptions={(search) => Picklist.fetchDealerTypePicklist(search, ppLocationValue, 7, trandate)}//service provider
                                                                            onInputChange={Picklist.handleInputChange}
                                                                            onChange={handleNewDealerChange}
                                                                            isDisabled={scrMode === "Q"}
                                                                        >
                                                                        </AsyncSelect>
                                                                    </Form.Group>
                                                                </Col>
                                                                <Row>
                                                                    <Col className='col-md-3 col-3'>
                                                                        <Form.Label>Name : <b>{dealerName}</b></Form.Label>
                                                                    </Col>
                                                                    <Col className="col-md-2 col-2">
                                                                        <span>Pan : <b>{dealerPan} </b></span>
                                                                    </Col>
                                                                    <Col className="col-md-2 col-2">
                                                                        <span>Gstin : <b>{dealerGsitn}</b></span>
                                                                    </Col>
                                                                    <Col>
                                                                        <span>Address : <b>{dealerAddress}</b></span>
                                                                    </Col>
                                                                </Row>
                                                            </>
                                                    }
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Label>Mode<span className='colorThemeRed'>*</span></Form.Label>
                                                        <Form.Select disabled={scrMode === "Q"} value={nMode} onChange={e => setNMode(e.target.value)}>
                                                            <option value="B">In Branch</option>
                                                            <option value="D">Delivery</option>
                                                        </Form.Select>
                                                    </Col>
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>Manual Number</Form.Label>
                                                            <AsyncSelect
                                                                cacheOptions={false}
                                                                defaultOptions={false}
                                                                value={nManualNo}
                                                                getOptionLabel={e => e.label + ' '}
                                                                getOptionValue={e => e.id}
                                                                loadOptions={(search) => Picklist.fetchManualTypePicklist(search, ppLocationValue, 'PP')} // location = 1 , 2
                                                                onInputChange={Picklist.handleInputChange}
                                                                onChange={handleManualNo}
                                                                isDisabled={scrMode === "Q"}
                                                            >
                                                            </AsyncSelect>
                                                        </Form.Group>
                                                    </Col>
                                                    {
                                                        nServiceType === "R" &&
                                                        <>
                                                            <Col className='col-md-3 col-6'>
                                                                <Form.Group>
                                                                    <Form.Label>Country Visited</Form.Label>
                                                                    <AsyncSelect
                                                                        cacheOptions={false}
                                                                        defaultOptions={false}
                                                                        value={nCountry}
                                                                        getOptionLabel={e => e.label + ' '}
                                                                        getOptionValue={e => e.id}
                                                                        loadOptions={(search) => Picklist.fetchCountryPicklist(search)} // location = 1 , 2
                                                                        onInputChange={Picklist.handleInputChange}
                                                                        onChange={handleNewCountry}
                                                                        isDisabled={scrMode === "Q"}
                                                                    >
                                                                    </AsyncSelect>
                                                                </Form.Group>
                                                            </Col>
                                                            <Col className='col-md-3 col-6'>
                                                                <Form.Group>
                                                                    <Form.Label>Residential Status<span className="colorThemeRed">*</span></Form.Label>
                                                                    <Form.Select disabled={scrMode === "Q"} value={nResident} onChange={e => setNResident(e.target.value)}>
                                                                        {
                                                                            residentOptions.map((item, index) => (
                                                                                <option value={item.mrs_srno} key={index}>{item.mrs_resident}</option>
                                                                            ))
                                                                        }
                                                                    </Form.Select>
                                                                </Form.Group>
                                                            </Col>
                                                            <Col className="col-md-12 col-12">
                                                                <Form.Group>
                                                                    <Form.Label style={{ display: "flex", alignItems: "center" }}>
                                                                        <span>Corporate</span>
                                                                        <span style={{ display: scrMode === "Q" && "none" }} className="mx-2" onClick={() => resetCorporate()}><Badge bg="secondary">Reset</Badge></span>
                                                                    </Form.Label>
                                                                    <AsyncSelect
                                                                        cacheOptions={false}
                                                                        defaultOptions={false}
                                                                        value={nCorporate}
                                                                        getOptionLabel={e => e.label + ' '}
                                                                        getOptionValue={e => e.id}
                                                                        loadOptions={(search) => Picklist.fetchLedgerPicklistByTypeNoValidityCheck(search, 'CORPORATE,DIVISION', ppLocationValue)} // location = 1 , 2
                                                                        onInputChange={Picklist.handleInputChange}
                                                                        onChange={handleCorporateChange}
                                                                        isDisabled={scrMode === "Q"}
                                                                    >
                                                                    </AsyncSelect>
                                                                </Form.Group>
                                                            </Col>
                                                            <Row>
                                                                <Col className='col-md-3 col-3'>
                                                                    <Form.Label>Name : <b>{corporateName}</b></Form.Label>
                                                                </Col>
                                                                <Col className="col-md-3 col-3">
                                                                    <span>Pan : <b>{corporatePan} </b></span>
                                                                </Col>
                                                                <Col className="col-md-2 col-2">
                                                                    <span>Gstin : <b>{corporateGstin}</b></span>
                                                                </Col>
                                                                <Col>
                                                                    <span>Address : <b>{corporateAddress}</b></span>
                                                                </Col>
                                                            </Row>

                                                            <Col className='col-md-3 col-6'>
                                                                <Form.Group>
                                                                    <Form.Label>{nServiceType === "R" ? "Corporate " : "Dealer "}Employee Code</Form.Label>
                                                                    <Form.Control disabled={scrMode === "Q"} placeholder='Employee Code' type='text' value={nEmployeeCode} onChange={e => Common.validateAlpNumValue(e.target.value, setNEmployeeCode)} maxLength={20} />
                                                                </Form.Group>
                                                            </Col>
                                                        </>
                                                    }
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>Place Of Supply</Form.Label>
                                                            <Select isDisabled options={stateOptions} value={nState} onChange={v => setNState(v)} />
                                                        </Form.Group>
                                                    </Col>
                                                    {
                                                        /*
                                                            <Col className='col-md-3 col-6'>
                                                                <Form.Group>
                                                                    <Form.Label>Purpose<span className="colorThemeRed">*</span></Form.Label>
                                                                    <AsyncSelect
                                                                        cacheOptions={false}
                                                                        defaultOptions={false}
                                                                        value={nPurpose}
                                                                        getOptionLabel={e => e.label + ' '}
                                                                        getOptionValue={e => e.id}
                                                                        loadOptions={Picklist.fetchPurchasePurposePicklist}
                                                                        onInputChange={Picklist.handleInputChange}
                                                                        onChange={v => setNPurpose(v)}
                                                                        isDisabled={scrMode === "Q"}
                                                                    >
                                                                    </AsyncSelect>
                                                                </Form.Group>
                                                            </Col>

                                                        */
                                                    }

                                                </Row>
                                                {
                                                    nServiceType === "R" &&
                                                    <Row>
                                                        {/* <Col className='col-md-3 col-6'>
                                                            <Form.Group>
                                                                <Form.Label>PAN/Form 60</Form.Label>
                                                                <Form.Select disabled={scrMode === "Q"} value={nDocument} onChange={e => setNDocument(e.target.value)}>
                                                                    <option value="">Select</option>
                                                                    <option value="F">Form 60</option>
                                                                    <option value="P">PAN</option>
                                                                </Form.Select>
                                                            </Form.Group>
                                                        </Col> */}
                                                        <Col className="col-md-3 col-6">
                                                            <Form.Group>
                                                                <Form.Label>LRS Reverse</Form.Label>
                                                                <Form.Select disabled={scrMode === "Q"} value={nLrsReverse} onChange={e => setNLrsReverse(e.target.value)}>
                                                                    <option value="1">Yes</option>
                                                                    <option value="0">No</option>
                                                                </Form.Select>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col className="col-md-3 col-6">
                                                            <Form.Group>
                                                                <Form.Label>Arrival Date<span className='colorThemeRed'>*</span></Form.Label>
                                                                <DatePicker className="form-control"
                                                                    selected={nArrivalDate}
                                                                    onChange={(date) => { setNArrivalDate(date); setArrivalSelected(1) }}
                                                                    dateFormat="dd/MM/yyyy"
                                                                    showYearDropdown
                                                                    showMonthDropdown
                                                                    useShortMonthInDropdown
                                                                    dropdownMode="select"
                                                                    peekNextMonth
                                                                    disabled={scrMode === "Q"}
                                                                    customInput={
                                                                        <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                                    }
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        {
                                                            (arrivalSelected === 1 && individualSelected === 1) &&
                                                            <Col className='col-md-3 col-6'>
                                                                <Form.Group>
                                                                    <Form.Label>CDF Number</Form.Label>
                                                                    <span style={{ display: scrMode === "Q" && "none" }} className="mx-2" onClick={handleCDFInfo}><Badge bg="secondary">CDF Info</Badge></span>
                                                                    <Form.Control disabled={scrMode === "Q"} maxLength={50} value={nCDFNum} onChange={e => setNCDFNum(e.target.value)} />
                                                                </Form.Group>
                                                            </Col>
                                                        }
                                                    </Row>
                                                }
                                                <Row>
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>Remark 1</Form.Label>
                                                            <Form.Control type="text" maxLength={100} placeholder='Remark 1' disabled={scrMode === "Q"} value={nRemark1} onChange={e => setNRemark1(e.target.value)} />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>Remark 2</Form.Label>
                                                            <Form.Control type="text" maxLength={100} placeholder='Remark 2' disabled={scrMode === "Q"} value={nRemark2} onChange={e => setNRemark2(e.target.value)} />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Row>&nbsp;</Row>
                                                <Row>
                                                    <Col>
                                                        <Button variant='outline-secondary' className='buttonStyle' size='sm' onClick={() => setKey("DETAILS")}>Product-&gt;</Button>
                                                    </Col>
                                                </Row>
                                            </Tab>
                                            <Tab eventKey="DETAILS" title="Details">
                                                <Row>
                                                    <Col>
                                                        <h4>Product Info</h4>
                                                    </Col>
                                                </Row>
                                                {
                                                    scrMode === "Q" ? null
                                                        :
                                                        <>
                                                            <Row>
                                                                <Col className='col-md-3 col-6'>
                                                                    <Form.Group>
                                                                        <Form.Label>Product<span className="colorThemeRed">*</span></Form.Label>
                                                                        <Form.Select value={pProduct} onChange={e => handleProductChange(e.target.value)} ref={productRef}>
                                                                            <option value="CN">CN</option>
                                                                            {nServiceType === 'R' && <>
                                                                                {/* <option value="ETC">TC</option> */}
                                                                                <option value="EVTM">EVTM</option>
                                                                            </>}
                                                                        </Form.Select>
                                                                    </Form.Group>
                                                                </Col>
                                                                {
                                                                    pProduct === "EVTM" ?  // filling automatically by vtm encashment
                                                                        null
                                                                        :
                                                                        <>
                                                                            < Col className="col-md-3 col-6">
                                                                                <Form.Group>
                                                                                    <Form.Label>ISD<span className="colorThemeRed">*</span></Form.Label>
                                                                                    <AsyncSelect
                                                                                        cacheOptions={false}
                                                                                        defaultOptions={false}
                                                                                        value={pIsd}
                                                                                        getOptionLabel={e => e.label + ' '}
                                                                                        getOptionValue={e => e.id}
                                                                                        loadOptions={(search) => Picklist.fetchCurrencyAllowedPicklist(search, pProduct)} // location = 1 , 2
                                                                                        onInputChange={Picklist.handleInputChange}
                                                                                        onChange={handleChangeIsd}
                                                                                    >
                                                                                    </AsyncSelect>
                                                                                </Form.Group>
                                                                            </Col>
                                                                            {
                                                                                pProduct === "ETC" || pProduct === "EVTM" ?
                                                                                    <Col className="col-md-3 col-6">
                                                                                        <Form.Group>
                                                                                            <Form.Label>Issuer<span className="colorThemeRed">*</span></Form.Label>
                                                                                            <AsyncSelect
                                                                                                cacheOptions={false}
                                                                                                defaultOptions={false}
                                                                                                value={pIssuer}
                                                                                                getOptionLabel={e => e.label + ' '}
                                                                                                getOptionValue={e => e.id}
                                                                                                loadOptions={(search) => Picklist.fetchLedgerPicklistByType(search, 'ISSUER', ppLocationValue)} // location = 1 , 2
                                                                                                onInputChange={Picklist.handleInputChange}
                                                                                                onChange={value => setPIssuer(value)}
                                                                                            >
                                                                                            </AsyncSelect>
                                                                                        </Form.Group>
                                                                                    </Col>
                                                                                    : null
                                                                            }
                                                                        </>
                                                                }
                                                            </Row>
                                                            {
                                                                pProduct === "EVTM" &&
                                                                <Row>
                                                                    <Col className='col-12'>
                                                                        <Form.Group>
                                                                            <Form.Label>EVtm's&nbsp;&nbsp;
                                                                                {pVtm !== null && <Badge bg='success' size='sm'>DSR: ({dsrRate})</Badge>}
                                                                            </Form.Label>
                                                                            <AsyncSelect
                                                                                cacheOptions={false}
                                                                                defaultOptions={false}
                                                                                value={pVtm}
                                                                                getOptionLabel={e => e.label + ' '}
                                                                                getOptionValue={e => e.id}
                                                                                loadOptions={(search) => Picklist.fetchVtmEncashmentPicklist(search, "APPROVED", ppLocationValue, nIndivualSrno, hdrSrno < 1 ? Common.dateYMD(ppNewDate) : hdrDateYmd)} // location = 1 , 2
                                                                                onInputChange={Picklist.handleInputChange}
                                                                                onChange={handleVtmValue}
                                                                                formatOptionLabel={Picklist.vtmEnchasementFormatOptionLabel}
                                                                                components={{ Menu: Picklist.vtmEnchasementMenu }}
                                                                            >
                                                                            </AsyncSelect>
                                                                        </Form.Group>
                                                                    </Col>
                                                                </Row>
                                                            }
                                                            <Row>
                                                                <Col display={{ display: pProduct === "EVTM" && "none" }} className='col-md-3 col-6'>
                                                                    <Form.Group>
                                                                        <Form.Label>{pProduct === "EVTM" ? "Value" : "Denomination"}
                                                                            <span className="colorThemeRed">*</span>
                                                                        </Form.Label>
                                                                        <Form.Control disabled={pProduct === "EVTM"} type='text' value={pDenomination} maxLength={5}
                                                                            onChange={e => handleDenoChange(e.target.value)} />
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col style={{ display: pProduct === "EVTM" && "none" }} className='col-md-3 col-6'>
                                                                    <Form.Group>
                                                                        <Form.Label>Quantity<span className="colorThemeRed">*</span></Form.Label>
                                                                        <Form.Control type='text' placeholder='Quantity' value={pQuantity} maxLength={9}
                                                                            onChange={e => handleQuantityChange(e.target.value)} />
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col className='col-md-3 col-6'>
                                                                    <Form.Group>
                                                                        <Form.Label>Rate<span className="colorThemeRed">*</span></Form.Label>
                                                                        <span style={{ display: scrMode === "Q" && "none" }} className="mx-2" onClick={handleMinMaxRate}><Badge bg="secondary">See Min/Max Rate</Badge></span>
                                                                        <Form.Control type='text' placeholder='Rate' value={pRate} maxLength={Common.rateMaxLength}
                                                                            onChange={e => handleRateChange(e.target.value)} />
                                                                    </Form.Group>
                                                                </Col>
                                                            </Row>
                                                            {
                                                                pProduct === "ETC" || pProduct === "EVTM" ?
                                                                    <Row>
                                                                        <Col className='col-md-3 col-6' style={{ display: pProduct === "EVTM" && "none" }}>
                                                                            <Form.Group>
                                                                                <Form.Label>Prefix</Form.Label>
                                                                                <Form.Control placeholder='Prefix' type='text' maxLength={5} value={prPrefix} onChange={e => Common.validateAlpNumValue(e.target.value, setPrPrefix)} />
                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col className='col-md-3 col-6'>
                                                                            <Form.Group>
                                                                                <Form.Label>From<span className="colorThemeRed">*</span></Form.Label>
                                                                                <Form.Control disabled={pProduct === "EVTM"} placeholder='From' type='text' maxLength={6} value={prFrom} onChange={e => handleFromChange(e.target.value)} />
                                                                            </Form.Group>
                                                                        </Col>
                                                                        {
                                                                            pProduct === "ETC" ?
                                                                                <Col className='col-md-3 col-6'>
                                                                                    <Form.Group>
                                                                                        <Form.Label>To<span className="colorThemeRed">*</span></Form.Label>
                                                                                        <Form.Control disabled placeholder='To' type='text' maxLength={6} value={prTo} onChange={e => Common.validateNumValue(e.target.value, setPrTo)} />
                                                                                    </Form.Group>
                                                                                </Col> :
                                                                                <Col className='col-md-3 col-6'>
                                                                                    <Form.Group>
                                                                                        <Form.Label>Card No</Form.Label>
                                                                                        <Form.Control disabled placeholder='Card No' type='text' value={pVtmCardNo} onChange={e => setPVtmCardNo(e.target.value)} />
                                                                                    </Form.Group>
                                                                                </Col>
                                                                        }
                                                                    </Row>
                                                                    : null
                                                            }
                                                            {
                                                                nServiceType === "G" &&
                                                                <>
                                                                    <Row>
                                                                        <Col className="col-md-3 col-6">
                                                                            <Form.Group>
                                                                                <Form.Label>Traveller Name {nServiceType === "G" && <span className="colorThemeRed">*</span>}</Form.Label>
                                                                                <Form.Control placeholder='Traveller Name' type='text' maxLength={50} value={pTravellerName} onChange={e => Common.validateAlpValue(e.target.value, setPTravellerName)} />
                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col className="col-md-3 col-6">
                                                                            <Form.Group>
                                                                                <Form.Label>ID type{nServiceType === "G" && <span className="colorThemeRed">*</span>}</Form.Label>
                                                                                <Form.Select value={pIdType} onChange={e => { handleIdType(e.target.value) }}>
                                                                                    {
                                                                                        idTypeList.map(item => <option key={item.value} value={item.value}>{item.label}</option>)
                                                                                    }
                                                                                </Form.Select>
                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col className="col-md-3 col-6">
                                                                            <Form.Group>
                                                                                <Form.Label>ID Number{nServiceType === "G" && <span className="colorThemeRed">*</span>}</Form.Label>
                                                                                <Form.Control placeholder='ID Number' type='text' maxLength={30} value={pIdNumber} onChange={e => Common.validateAlpNumValue(e.target.value, setPIdNumber)}
                                                                                    onBlur={idNumberHandler} />
                                                                            </Form.Group>
                                                                        </Col>
                                                                    </Row>
                                                                    &nbsp;
                                                                    <Row>
                                                                        {isIDIssueDate == 1 &&
                                                                            <Col className='col-md-3 col-6'>
                                                                                <Form.Group>
                                                                                    <Form.Label>Issue Date{nServiceType === "G" && <span className="colorThemeRed">*</span>}</Form.Label>
                                                                                    <DatePicker className="form-control"
                                                                                        selected={pIdIssueDate}
                                                                                        onChange={(date) => setPidIssueDate(date)}
                                                                                        maxDate={new Date()}
                                                                                        dateFormat="dd/MM/yyyy"
                                                                                        showYearDropdown
                                                                                        showMonthDropdown
                                                                                        useShortMonthInDropdown
                                                                                        dropdownMode="select"
                                                                                        peekNextMonth
                                                                                        customInput={
                                                                                            <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                                                        }
                                                                                    />
                                                                                </Form.Group>
                                                                            </Col>
                                                                        }
                                                                        {isIDExpiryDate == 1 &&
                                                                            <Col className='col-md-3 col-6'>
                                                                                <Form.Group>
                                                                                    <Form.Label>Expiry Date{nServiceType === "G" && <span className="colorThemeRed">*</span>}</Form.Label>
                                                                                    <DatePicker className="form-control"
                                                                                        selected={pIdExpiryDate}
                                                                                        onChange={(date) => setPidExpiryDate(date)}
                                                                                        minDate={new Date()}
                                                                                        dateFormat="dd/MM/yyyy"
                                                                                        showYearDropdown
                                                                                        showMonthDropdown
                                                                                        useShortMonthInDropdown
                                                                                        dropdownMode="select"
                                                                                        peekNextMonth
                                                                                        customInput={
                                                                                            <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                                                        }
                                                                                    />
                                                                                </Form.Group>
                                                                            </Col>
                                                                        }
                                                                    </Row>
                                                                </>

                                                            }
                                                            &nbsp;

                                                            <Row>

                                                                <Col className='col-md-3 col-6'>
                                                                    <Form.Group>
                                                                        <Form.Label>Commission</Form.Label>
                                                                        <Form.Select value={isCommission} onChange={e => handleSetIsCommission(e.target.value)}>
                                                                            <option value="0">No</option>
                                                                            <option value="1">Yes</option>
                                                                        </Form.Select>
                                                                    </Form.Group>
                                                                </Col>
                                                                {
                                                                    +isCommission === 1 ?
                                                                        <>
                                                                            <Col className='col-md-12 col-12'>
                                                                                <Form.Group>
                                                                                    <Form.Label>Agent<span className="colorThemeRed">*</span></Form.Label>
                                                                                    <AsyncSelect
                                                                                        cacheOptions={false}
                                                                                        defaultOptions={false}
                                                                                        value={pAgent}
                                                                                        getOptionLabel={e => e.label + ' '}
                                                                                        getOptionValue={e => e.id}
                                                                                        loadOptions={(search) => Picklist.fetchLedgerPicklistByType(search, 'AGENT', ppLocationValue)} // location = 1 , 2
                                                                                        onInputChange={Picklist.handleInputChange}
                                                                                        onChange={handleAgentChange}
                                                                                        isDisabled={nServiceType === "G"}
                                                                                    >
                                                                                    </AsyncSelect>
                                                                                </Form.Group>
                                                                            </Col>
                                                                            <Row>
                                                                                <Col className='col-md-3 col-3'>
                                                                                    <Form.Label>Name : <b>{agentName}</b></Form.Label>
                                                                                </Col>
                                                                                <Col className="col-md-2 col-2">
                                                                                    <span>Pan : <b>{agentPan} </b></span>
                                                                                </Col>
                                                                                <Col>
                                                                                    <span>Address : <b>{agentAddress}</b></span>
                                                                                </Col>
                                                                            </Row>
                                                                            <Col className="col-md-3 col-6">
                                                                                <Form.Group>
                                                                                    <Form.Label>Type<span className="colorThemeRed">*</span></Form.Label>
                                                                                    <Form.Select value={commType} onChange={e => commissionTypeChange(e.target.value)}
                                                                                        disabled={true}
                                                                                    >
                                                                                        <option value="F">Flat</option>
                                                                                        <option value="">Select</option>
                                                                                        <option value="P">Paisa</option>
                                                                                        <option value="R">Percentage</option>

                                                                                    </Form.Select>
                                                                                </Form.Group>
                                                                            </Col>
                                                                            <Col>
                                                                                <Form.Group>
                                                                                    <Form.Label>Commission<span className="colorThemeRed">*</span></Form.Label>
                                                                                    <Form.Control type='text' maxLength={5} value={commission} onChange={e => handleCommissionCalc(e.target.value)} />
                                                                                </Form.Group>
                                                                            </Col>
                                                                            <Col>
                                                                                <Form.Group>
                                                                                    <Form.Label>Commission Value</Form.Label>
                                                                                    <Form.Control disabled value={commValue} onChange={e => Common.validateDecValue(e.target.value, setCommValue)} />
                                                                                </Form.Group>
                                                                            </Col>
                                                                        </>
                                                                        : null
                                                                }
                                                            </Row>
                                                            <Row>&nbsp;</Row>
                                                            <Row>
                                                                <Col>
                                                                    <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={() => addProduct()}>Add</Button>
                                                                    &nbsp;
                                                                    <Button variant='outline-secondary' className='buttonStyle' size='sm' onClick={() => setKey("PAYMENT")} onKeyDown={switchToPaymentTab}>Payment-&gt;</Button>
                                                                </Col>
                                                            </Row>
                                                        </>
                                                }
                                                <Row>
                                                    <Col className="col-md-3 col-6">
                                                        {/* <Badge className='handCursor' bg="primary" onClick={handleShowCommissionDetail}>View Commission Details</Badge> */}
                                                        <Form.Check type='checkbox' checked={showCommissionDetail} onChange={e => setShowCommissionDetail(e.target.checked)} label='Commission Details' />
                                                    </Col>
                                                </Row>
                                                <Row>&nbsp;</Row>
                                                <Row>
                                                    <Table responsive bordered striped>
                                                        <thead>
                                                            <tr>
                                                                <th>&nbsp;</th>
                                                                <th>Product</th>
                                                                <th>Isd Code</th>
                                                                <th>Isd Name</th>
                                                                <th>Denomination</th>
                                                                <th>Quantity</th>
                                                                <th>Rate</th>
                                                                <th>Amount</th>
                                                                <th>USD Rate</th>
                                                                <th>USD Amount</th>
                                                                <th>Prefix</th>
                                                                <th>From</th>
                                                                <th>To</th>
                                                                {
                                                                    showCommissionDetail &&
                                                                    <>
                                                                        <th>Agent</th>
                                                                        <th>Commission Type</th>
                                                                        <th>Commission</th>
                                                                        <th>Commission Value</th>
                                                                    </>
                                                                }
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                pProductList.map((item, index) => (
                                                                    <>
                                                                        <tr key={index}>
                                                                            <td>
                                                                                {
                                                                                    scrMode === "Q" || item.delny === "N" ? null :
                                                                                        <span onClick={() => deleteProduct(item.uniquekey, item.prd_vtm_num, item.prd_product)} className='colorThemeBlue pointer'>
                                                                                            <FontAwesomeIcon icon={faTrash} />
                                                                                        </span>
                                                                                }
                                                                            </td>
                                                                            <td>{item.prd_product}</td>
                                                                            <td>{item.prd_isd}</td>
                                                                            <td>{item.isd_name}</td>
                                                                            <td>{item.prd_deno}</td>
                                                                            <td>{item.prd_qty}</td>
                                                                            <td>{item.prd_rate}</td>
                                                                            <td>{item.prd_amount}</td>
                                                                            <td>{item.prd_usd_rate}</td>
                                                                            <td>{item.prd_usd_amount}</td>
                                                                            <td>{item.prd_prefix}</td>
                                                                            <td>{item.prd_from}</td>
                                                                            <td>{item.prd_to}</td>
                                                                            {
                                                                                showCommissionDetail &&
                                                                                <>
                                                                                    {
                                                                                        item.prd_agent_group == "0" ?
                                                                                            <td></td> :
                                                                                            <td>{item.prd_agent_group + " " + item.prd_agent_ledger + " " + item.prd_agent_name}</td>
                                                                                    }
                                                                                    <td>{item.prd_commission_type === "P" ? "Paisa"
                                                                                        : item.prd_commission_type === "R" ? "Percentage"
                                                                                            : item.prd_commission_type === "F" ? "Flat" : ""}</td>
                                                                                    <td>{item.prd_commission * 1 > 0 ? item.prd_commission : ""}</td>
                                                                                    <td>{item.prd_commission_value * 1 > 0 ? item.prd_commission_value : ""}</td>
                                                                                </>
                                                                            }
                                                                        </tr>
                                                                        {
                                                                            item.prd_product === "EVTM" ? <>
                                                                                <tr key={index + '1'} >
                                                                                    <td colspan="13" >
                                                                                        Br Surr : {item.prd_stb_date_dmy}&nbsp;{item.prd_stb_type}-{item.prd_stb_srno}&nbsp;
                                                                                        {
                                                                                            1 * item.prd_stc_srno > 0 ? <>
                                                                                                &nbsp;Corp Sett : {item.prd_stc_date_dmy}&nbsp;{item.prd_stc_type}-{item.prd_stc_srno}&nbsp;
                                                                                            </> : null
                                                                                        }

                                                                                    </td>
                                                                                </tr>
                                                                            </> : null
                                                                        }
                                                                        {/* {nServiceType === 'G' &&
                                                                            <tr>
                                                                                <td colSpan={17}>
                                                                                    {'<b> Traveller Name </b>' + item.prd_traveller_name + " , " +'<b>'+ (idTypeList.find((id) => id.value.split('^')[1] == item.prd_id_type))?.label+'</b>' + ' : ' + item.prd_id_number + (item.prd_id_expiry_date != '1900-12-31' ? " ,<strong> Issued</strong> :" + Common.dateDMYStr(item.prd_id_issue_date) : '') + (item.prd_id_expiry_date != '2025-01-25' ? " ,<b> Expire</b> :" + Common.dateDMYStr(item.prd_id_expiry_date) : '')}
                                                                                </td>
                                                                            </tr>
                                                                        } */}
                                                                        {nServiceType === 'G' && (
                                                                            <tr>
                                                                                <td colSpan={17}>
                                                                                    <b>Traveller Name</b> {item.prd_traveller_name}, <b>
                                                                                        {(idTypeList.find((id) => id.value.split('^')[1] == item.prd_id_type))?.label}
                                                                                    </b> : {item.prd_id_number}
                                                                                    {item.prd_id_expiry_date !== '1900-12-31' && (
                                                                                        <>
                                                                                            , <strong>Issued</strong>: {Common.dateDMYStr(item.prd_id_issue_date)}
                                                                                        </>
                                                                                    )}
                                                                                    {item.prd_id_expiry_date !== '2025-01-25' && (
                                                                                        <>
                                                                                            , <b>Expire</b>: {Common.dateDMYStr(item.prd_id_expiry_date)}
                                                                                        </>
                                                                                    )}
                                                                                    <b>Agent : </b> {item.prd_agent_group} {item.prd_agent_ledger} {item.prd_agent_name},<b> Commission : </b>  {item.prd_commission}
                                                                                    {item.prd_commission_type === "P" ? " Paisa " : item.prd_commission_type === "R" ? " Percentage " : item.prd_commission_type === "F" ? " Flat " : ""}
                                                                                    <b>Commission Value : </b> {item.prd_commission_value}
                                                                                </td>
                                                                            </tr>
                                                                        )}

                                                                        {/* <tr>
                                                                            <td colSpan={17}>
                                                                                {<b>ISD </b> + item.prd_isd + " , " + <b> ISD </b>+ item.prd_agent_group + " " + item.prd_agent_ledger + ' ' + item.prd_agent_name + " , " + (item.prd_commission_type === "P" ? "Paisa" : item.prd_commission_type === "R" ? "Percentage" : item.prd_commission_type === "F" ? "Flat" : "") + " , " + item.prd_commission + " , " + item.prd_commission_value}
                                                                            </td>
                                                                        </tr> */}
                                                                        {/* <tr>
                                                                            <td colSpan={17}>
                                                                                <b>Agent : </b> {item.prd_agent_group} {item.prd_agent_ledger} {item.prd_agent_name},<b> Commission Type : </b>  {item.prd_commission}
                                                                                {item.prd_commission_type === "P" ? " Paisa " : item.prd_commission_type === "R" ? " Percentage " : item.prd_commission_type === "F" ? " Flat " : ""}
                                                                               <b>Commission Value : </b> { item.prd_commission_value}
                                                                            </td>
                                                                        </tr> */}

                                                                    </>
                                                                ))
                                                            }
                                                        </tbody>
                                                    </Table>
                                                </Row>
                                            </Tab>
                                            <Tab eventKey="PAYMENT" title="Payment">
                                                <Row>
                                                    <Col className="col-md-2 col-4">
                                                        <Form.Label>Taxable Value: {pTaxableVal}</Form.Label>
                                                    </Col>
                                                    <Col className="col-md-2 col-4">
                                                        <Form.Label>SGST: {pSgst}</Form.Label>
                                                    </Col>
                                                    <Col className="col-md-2 col-4">
                                                        <Form.Label>IGST: {pIgst}</Form.Label>
                                                    </Col>
                                                    <Col className="col-md-2 col-4">
                                                        <Form.Label>CGST : {pCgst}</Form.Label>
                                                    </Col>
                                                    <Col className="col-md-2 col-4">
                                                        <Form.Label>UGST : {pUgst}</Form.Label>
                                                    </Col>
                                                    <Col className="col-md-2 col-4">
                                                        <Form.Label>Round Off: {pRoundOff}</Form.Label>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col className="col-md-3 col-6" style={{ display: "flex", alignItems: "center" }}>
                                                        <Form.Group>
                                                            <Form.Label>OtherCharges: &nbsp;
                                                                {
                                                                    scrMode !== "Q" &&
                                                                    <Badge className='mx-2 pointer' bg='danger' onClick={() => exclusiveGSTHandler()}>Inclusive GST</Badge>
                                                                }
                                                            </Form.Label>
                                                            <Form.Control size='sm' placeholder='Other Charges' type='text'
                                                                maxLength={10}
                                                                value={pOtherCharges}
                                                                onChange={e => otherChargeChange(e.target.value)}
                                                                disabled={disableOtherCharge || scrMode === "Q" || otherChargesInputVisibility}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    {otherChargesInputVisibility && <Col className="col-md-3 col-6" style={{ display: "flex", alignItems: "center" }}>
                                                        <Form.Group>
                                                            <Form.Label>Inclusive GST: &nbsp;</Form.Label>

                                                            <Form.Control size='sm' placeholder='Other Charges' type='text'
                                                                maxLength={10}
                                                                value={pExclusiveGst}
                                                                onChange={e => gstExclusiveHandler(e.target.value)}
                                                            />

                                                        </Form.Group>
                                                    </Col>
                                                    }
                                                </Row>
                                                <hr />
                                                <Row>
                                                    <Col><h3>Payment Details</h3></Col>
                                                </Row>
                                                {
                                                    scrMode === "Q" ? null
                                                        :
                                                        <>
                                                            <Row>
                                                                <Col className='col-md-3 col-6'>
                                                                    <Form.Group>
                                                                        <Form.Label>Payment Type</Form.Label>
                                                                        <Form.Select value={pdPaymentType} onChange={e => handlePaymentType(e.target.value)}
                                                                        //  onBlur={e => handlePaymentType(e.target.value)}
                                                                        >
                                                                            <option value="">Select</option>
                                                                            {
                                                                                nServiceType === "R" &&
                                                                                <option value="CH">Cash</option>
                                                                            }
                                                                            <option value="BN">Bank</option>
                                                                            <option value="CQ">Cheque</option>
                                                                            {/* <option value="RC">Recievables</option> */}
                                                                            <option value="PB">Payables</option>
                                                                            {/* <option value="AP">Advance Paid</option>
                                                                            <option value="AR">Advance Recieved</option> */}
                                                                        </Form.Select>
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col className='col-md-3 col-6'>
                                                                    <Form.Group>
                                                                        <Form.Label>Account<span className="colorThemeRed">*</span></Form.Label>
                                                                        <AsyncSelect
                                                                            cacheOptions={false}
                                                                            defaultOptions={false}
                                                                            value={pdAccount}
                                                                            getOptionLabel={e => e.label + ' '}
                                                                            getOptionValue={e => e.id}
                                                                            loadOptions={(search) => Picklist.fetchLedgerPicklistByType(search, ldgSrchType, ppLocationValue)} // location = 1 , 2
                                                                            onInputChange={Picklist.handleInputChange}
                                                                            onChange={handleAccountValue}
                                                                            isDisabled={disablePaymentAccount}
                                                                        >
                                                                        </AsyncSelect>
                                                                    </Form.Group>
                                                                </Col>
                                                                {
                                                                    pdPaymentType !== "" ?
                                                                        <Col className='col-md-3 col-6'>
                                                                            <Form.Group>
                                                                                <Form.Label>Amount</Form.Label>
                                                                                <Form.Control placeholder='Amount' value={pdAmount} onChange={e => Common.validateDecValue(e.target.value, setPdAmount)} />
                                                                            </Form.Group>
                                                                        </Col> : null
                                                                }
                                                            </Row>
                                                            {
                                                                pdPaymentType === "BN" ?
                                                                    <Row>
                                                                        <Col className="col-md-12">
                                                                            <Form.Group>
                                                                                <Form.Label>Reference No<span className="colorThemeRed">*</span></Form.Label>
                                                                                <Form.Control placeholder='Reference No' maxLength={255} value={pdChequeNum} onChange={e => Common.validateAlpNumSplValue(e.target.value, setPdChequeNum)} />
                                                                            </Form.Group>
                                                                        </Col>
                                                                    </Row>
                                                                    : pdPaymentType === "CQ" ?
                                                                        <Row>
                                                                            <Col className="col-md-3 col-6">
                                                                                <Form.Group>
                                                                                    <Form.Label>Cheque No<span className="colorThemeRed">*</span></Form.Label>
                                                                                    <AsyncSelect
                                                                                        cacheOptions={false}
                                                                                        defaultOptions={false}
                                                                                        value={chequeValue}
                                                                                        getOptionLabel={e => e.label + ' '}
                                                                                        getOptionValue={e => e.id}
                                                                                        loadOptions={(search) => Picklist.fetchChequeBookBankPicklist(search, pdGroupValue, pdAccountValue, ppLocationValue)}
                                                                                        onInputChange={Picklist.handleInputChange}
                                                                                        onChange={handleChequeValue}
                                                                                    >
                                                                                    </AsyncSelect>
                                                                                </Form.Group>
                                                                            </Col>
                                                                        </Row>
                                                                        : (pdPaymentType === "PB" && nCorporate === null && nDealer === null) ?
                                                                            <Row>

                                                                                <Col className="col-md-3 col-6">
                                                                                    <Form.Label>Bank Name</Form.Label>
                                                                                    <AsyncSelect
                                                                                        cacheOptions={false}
                                                                                        defaultOptions={false}
                                                                                        value={ldgAllBank}
                                                                                        getOptionLabel={e => e.label + ' '}
                                                                                        getOptionValue={e => e.id}
                                                                                        loadOptions={Picklist.fetchAllBankPicklist}
                                                                                        onInputChange={Picklist.handleInputChange}
                                                                                        onChange={handleAllBankChange}
                                                                                        isDisabled={scrMode === "Q"}
                                                                                    >
                                                                                    </AsyncSelect>
                                                                                </Col>
                                                                                <Col className="col-md-3 col-6">
                                                                                    <Form.Group>
                                                                                        <Form.Label>Account Number <span className="colorThemeRed">*</span></Form.Label>
                                                                                        <Form.Control disabled={scrMode === "Q"} placeholder='Account' type='text' maxLength={250} value={nAccountNo}
                                                                                            onChange={e => Common.validateAlpNumValue(e.target.value, setNAccountNo)}
                                                                                        />
                                                                                    </Form.Group>
                                                                                </Col>
                                                                                <Col className="col-md-3 col-6">
                                                                                    <Form.Group>
                                                                                        <Form.Label>IFSC No <span className="colorThemeRed">*</span></Form.Label>
                                                                                        <Form.Control disabled={scrMode === "Q"} placeholder='Account' type='text' maxLength={250} value={nIfscCode}
                                                                                            onChange={e => Common.validateAlpNumValue(e.target.value, setNIfscCode)}
                                                                                        />
                                                                                    </Form.Group>
                                                                                </Col>
                                                                            </Row>
                                                                            : null
                                                            }
                                                            <Row>&nbsp;</Row>
                                                            <Row>
                                                                <Col>
                                                                    <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => addPayment()}>Add</Button>
                                                                </Col>
                                                            </Row>
                                                        </>
                                                }
                                                <Row>&nbsp;</Row>
                                                <Row>
                                                    <Table responsive striped bordered>
                                                        <thead>
                                                            <tr>
                                                                <th>&nbsp;</th>
                                                                <th>Type</th>
                                                                <th>Group</th>
                                                                <th>Account</th>
                                                                <th>Name</th>
                                                                <th>Amount</th>
                                                                <th>Cheque</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                paymentData.map((item, index) => (
                                                                    <>
                                                                        <tr key={index}>
                                                                            <td>
                                                                                {
                                                                                    scrMode !== "Q" && item.delny === "Y" ?
                                                                                        <span className='colorThemeBlue pointer' onClick={() => deletePayment(item)}>
                                                                                            <FontAwesomeIcon icon={faTrash} />
                                                                                        </span> : null
                                                                                }
                                                                            </td>
                                                                            <td>
                                                                                {
                                                                                    item.tp_payment_type === "BN"
                                                                                        ? "Bank" : item.tp_payment_type === "CQ"
                                                                                            ? "Cheque" : item.tp_payment_type === "CH"
                                                                                                ? "Cash" : item.tp_payment_type === "RC"
                                                                                                    ? "Receivables" : item.tp_payment_type === "PB"
                                                                                                        ? "Payables" : item.tp_payment_type === "AP"
                                                                                                            ? "Advance Paid" : item.tp_payment_type === "AR"
                                                                                                                ? "Advance Received" : ""
                                                                                }
                                                                            </td>
                                                                            <td>{item.tp_group}</td>
                                                                            <td>{item.tp_account}</td>
                                                                            <td>{item.mvli_ledger_name}</td>
                                                                            <td>{item.tp_amount}</td>
                                                                            <td>{item.tp_payment_type === "BN" ? item.tp_cheque : item.tp_payment_type === "CQ" ? item.tcbb_from : ''}</td>
                                                                        </tr>
                                                                        <tr key={`hi+${index}`} >
                                                                            <td colSpan={15}>
                                                                                Bank Code : {item.bank_code} , Account no : {item.accnum} , IFSC : {item.ifsc}
                                                                            </td >
                                                                        </tr>
                                                                    </>
                                                                ))
                                                            }
                                                        </tbody>
                                                    </Table>
                                                </Row>
                                            </Tab>
                                        </Tabs>
                                        <hr />
                                        <Row>
                                            <Col>
                                                <Button variant='outline-danger' size='sm' className='buttonStyle' onClick={() => cancelConfirm()}>Back</Button>
                                                &nbsp;
                                                {
                                                    (+userRight.edit === 1 && scrMode === 'Q' && cancelButtonView) ? <>
                                                        <Button style={{ display: +isIrnGenerated === 1 && "none" }} variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                            btnEditRequest()}>Edit</Button>&nbsp;
                                                    </> : null
                                                }
                                                {
                                                    (+userRight.edit === 1 && scrMode === 'E') || (+userRight.add === 1 && scrMode === 'A') ? <>
                                                        <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => saveData(false)}>Save</Button>&nbsp;
                                                    </> : null
                                                }
                                                {
                                                    (+userRight.query === 1 && scrMode === "Q") ? <>
                                                        {
                                                            +Common.Billprint === 1 &&
                                                            <>
                                                                <Button variant='outline-success' size='sm' className='buttonStyle divHide' onClick={() => print("D")}>With Deno</Button>&nbsp;
                                                                <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => print("")}>Without Deno</Button>&nbsp;
                                                            </>
                                                        }
                                                        <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={() => handleFaView()}>Fa View</Button>&nbsp;
                                                        {(+userRight.edit === 1 && scrMode === 'Q') ? <>
                                                            <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                                btnActivityLog()}>Activity Log</Button>&nbsp;
                                                        </> : null
                                                        }
                                                    </> : null
                                                }
                                                {
                                                    (scrMode === "Q" && +userRight.add === 1) &&
                                                    < Button variant="outline-secondary" className='buttonStyle' size="sm" onClick={() => addNewForm()}>Add New</Button>
                                                }
                                                {
                                                    (scrMode === "Q" && +userRight.delete === 1) &&
                                                    <>
                                                        &nbsp;
                                                        {+dateChangeRight?.query === 1 &&
                                                            <Button variant="outline-danger" className='buttonStyle' size="sm" onClick={() => changeDateModal()}>Date Change</Button>}
                                                    </>
                                                }
                                                {
                                                    (scrMode === "Q" && +userCancelBillRight.query === 1 && cancelButtonView) &&
                                                    <>
                                                        &nbsp;
                                                        <Button variant="outline-danger" className='buttonStyle' size="sm" onClick={() => handleCancelBill()}>Cancel Bill</Button>
                                                    </>
                                                }
                                            </Col>
                                        </Row>
                                        <Row>&nbsp;</Row>
                                    </>
                            }
                        </Container>
                    </>
            }
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
            <ActivityLog logObject={logObject} show={showActivityLog} onHide={() => setShowActivityLog(false)} />
            <Modal show={showPreviousTransactionModal} size='xl' onHide={() => setShowPreviousTransactionModal(false)} scrollable backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>
                        <Row>
                            <Col>
                                <span>Previous Transaction</span>
                                <span>&nbsp;</span>
                            </Col>
                        </Row>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>&nbsp;</Row>
                    <Row>
                        <Table striped responsive bordered>
                            <thead>
                                <tr>
                                    <th> Branch</th>
                                    <th>Type</th>
                                    <th>Certificate</th>
                                    <th>Date</th>
                                    <th>USD</th>
                                    <th>Arrival</th>
                                    <th>Cash</th>
                                    <th>Bank</th>
                                    <th>Receivable</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    preTransaction.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.entity_name}</td>
                                            <td>{item.tp_type}</td>
                                            <td>{item.hdr_srno}</td>
                                            <td>{item.hdr_date}</td>
                                            <td>{item.prd_usd_amount}</td>
                                            <td>{item.hdr_arrival_date}</td>
                                            <td>{item.tp_payment_type === "CH" ? item.tp_amount : ""}</td>
                                            <td>{item.tp_payment_type === "BN" ? item.tp_amount : ""}</td>
                                            <td>{item.tp_payment_type === "RC" ? item.tp_amount : ""}</td>

                                        </tr>
                                    ))
                                }
                            </tbody>
                        </Table>
                    </Row>
                </Modal.Body>
            </Modal>
            <Modal show={showMinMaxRateModal} size='xl' onHide={() => setShowMinMaxRateModal(false)} scrollable backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>
                        <Row>
                            <Col>
                                <span>MIN/MAX RATE CARD</span>
                                <span>&nbsp;</span>
                            </Col>
                        </Row>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>&nbsp;</Row>
                    <Row>
                        <Table striped responsive bordered>
                            <thead>
                                <tr>
                                    <th>ISD</th>
                                    <th> MINIMUM</th>
                                    <th>RATE</th>
                                    <th>MAXIMUM</th>
                                </tr>
                            </thead>
                            <tbody>
                                {minMaxRate.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.isd}</td>
                                        <td>{item.minbuyrate}</td>
                                        <td>{item.buyrate}</td>
                                        <td>{item.maxbuyrate}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Row>
                </Modal.Body>
            </Modal>
            <span className="corner-span">{counter}</span>

            <FaView faViewObject={faViewObject} show={showFaView} onHide={() => setShowFaView(false)} />

            {/* <Tran_commission_view show={showCommissionDetail} onHide={() => setShowCommissionDetail(false)} productList={pProductList} /> */}

            <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                {msgText}
            </Dialog>
            <DialogYesNo isOpen={isMsgBoxYN} onYes={(e) => cancelData()} onNo={(e) => setMsgBoxYN(false)}>
                {msgTextYN}
            </DialogYesNo>
            <CancelDialog isOpen={msgBoxYNBillDelete} onYes={handleDeleteBill} billDetails={{ type: "PP", isirn: isIrnGenerated }} onNo={(e) => setMsgBoxYNBillDelete(false)}>
                {msgTextYNBillDelete}
            </CancelDialog>
            <DialogYesNo isOpen={isMsgBoxYNevtm} onYes={(e) => handleAddEVtm()} onNo={(e) => setMsgBoxYNevtm(false)}>
                {msgTextYNevtm}
            </DialogYesNo>
            <Dialog_IRN
                isOpen={isMsgBoxCancelBill}
                onYes={(e) => cancelBill()}
                onNo={(e) => setMsgBoxCancelBill(false)}
                text={msgTextCancelBill}
                checkLabel={irnCancelLabel}
                irnCancelDeclaration={irnCancelDeclaration}
                setIrnCancelDeclaration={setIrnCancelDeclaration}
                irnCancelReason={irnCancelReason}
                setIrnCancelReason={setIrnCancelReason}
                irnCancelReasonSelect={irnCancelReasonSelect}
                setIrnCancelReasonSelect={setIrnCancelReasonSelect}
            />
            <div>
                <Modal size='lg' show={showModal} onHide={() => setShowModal(false)} animation={false} centered>
                    <Modal.Body>
                        <>
                            <h4>{riskModalBoxText}</h4>
                            <Form.Group>
                                <Form.Label>Action Taken<span className="text-danger">*</span></Form.Label>
                                <Form.Control type="text" placeholder="Reason" maxLength={499}
                                    value={acRemark}
                                    onChange={(e) => Common.validateAlpValue(e.target.value, setAcRemark)}
                                    autoComplete="off"
                                    required />
                            </Form.Group>
                        </>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="outline-success" onClick={() => saveData(true)}>
                            Save
                        </Button>{' '}
                        <Button variant="outline-success" onClick={() => setShowModal(false)}>
                            Cancel
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>

            <Tran_data_unlock_request logObject={editLogObject} show={showEditRequest} onHide={() => setShowEditRequest(false)} />
            <Tran_date_change_modal openDateChangeModal={openDateChangeModal} setOpenDateChangeModal={setOpenDateChangeModal} changeDateObj={changeDateObj} setMsgBox={setMsgBox} setMsgText={setMsgText} fillViewForm={fillViewForm} />
            <Tran_passport_form show={showPassForm} onHide={() => setShowPassForm(false)} proceedHandler={hideIndividualProfile} type="PP" />

        </>
    )
}

export default Tran_pp